

// Datei: src/shop.js
//shop.js
/**
 * ===================================================================
 * I. Globale Variablen & Konfiguration
 * ===================================================================
 */



window.zoom_history = null;
window.check_content_usicht_filter = false;

/**
 * ===================================================================
 * II. Performance-optimierte Utility-Funktionen
 * ===================================================================
 */

const Utils = {
    getRandom(min, max) {
        if (min > max) return -1;
        if (min === max) return min;
        return min + Math.floor(Math.random() * (max - min + 1));
    },

    // Optimiertes Clipboard mit Promise
    async copyToClipboard(text) {
        if (navigator.clipboard?.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                return true;
            } catch {
                return this.fallbackCopy(text);
            }
        }
        return this.fallbackCopy(text);
    },

    fallbackCopy(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        Object.assign(textArea.style, {
            position: 'fixed',
            top: '0',
            left: '0',
            opacity: '0',
            pointerEvents: 'none'
        });
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        let success = false;
        try {
            success = document.execCommand('copy');
        } catch (error) {
            console.error(error);
        }
        document.body.removeChild(textArea);
        return success;
    },

    formatPrice(price) {
        const parts = price.split(',');
        return `${parts[0]}.<sup>${parts[1]}</sup>`;
    },

    showErrorBox(element, selector, message) {
        // Null-Guard: zahlungsarten[0] ist undefined, wenn keine Zahlart im DOM
        // steht — ohne den wirft undefined.closest() und der Handler bricht ab,
        // bevor preventDefault() greift.
        if (!element) return;

        const box = element.closest(selector);
        if (!box) return;
        
        box.classList.add("box_error_ani");

        // Klartext statt blosser Wackel-Animation. Der Hinweis bleibt stehen,
        // bis das Feld korrigiert ist — die Animation endet nach 1,5 s.
        if (message) {
            let hint = box.querySelector(".kasse_fehler_hinweis");
            if (!hint) {
                hint = document.createElement("p");
                hint.className = "kasse_fehler_hinweis";
                hint.setAttribute("role", "alert");
                hint.style.cssText = "color: var(--color-brand); font-weight: bold; margin: 0 0 0.5em 0;";
                box.insertBefore(hint, box.firstChild);
            }
            hint.textContent = message;
        }

        box.scrollIntoView({ behavior: "smooth", block: "center" });
        
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                setTimeout(() => box.classList.remove("box_error_ani"), 1500);
                observer.disconnect();
            }
        });
        observer.observe(box);
    },

    // Batch DOM-Updates für bessere Performance
    batchDOMUpdates(updates) {
        scheduleRAF(() => updates());
    },

    cleanupRAF() {
        rafManager.cancelAll();
    }
};

/**
 * ===================================================================
 * III. DOM-Cache Manager (Performance-Optimierung)
 * ===================================================================
 */

// shop.js - NUR NOCH SHOP-SPEZIFISCHER STATE
const STATE = {
    observers: {
        usichtPage: new Map(),
        contentUsicht: new Map(),
        bannerBox: null
    },
    cache: {
        isMobile: html.classList.contains("mobile_size"),
        hasDataSection: !!domCache.get('div[data-section]'),
        headerDiv: null,
        headerDivHeight: 0,
        galaxyElement: null,
        galaxyInitialized: false
    },
    counters: {
        usichtPage: 0
    },
    scroll: {
        last: 0,
        toTop: 0
    }
};

// DOM-Cache ist jetzt global verfügbar als window.domCache oder window.domCache
/**
 * ===================================================================
 * OPTIMIERTER SCROLL & RESIZE HANDLER
 * - Keine Reflows während Scroll
 * - Gecachte Werte
 * - Minimale DOM-Zugriffe
 * - RAF-basiertes Batching
 * ===================================================================
 */

const ScrollHandler = {
    cache: {
        header: null,
        html: null,
        headerDiv: null,
        headerHeight: 0,
        headerDivHeight: 0,
        hasDataSection: false,
        galaxyElement: null,
        galaxyInitialized: false,
        cssEm: 0,
        lastScrollY: 0,
        ticking: false,
        headerHasDown: false,
        headerHasUp: false,
        htmlHasDown: false,
        isAbsolutePosition: false
    },

    init() {
        const c = this.cache;
        c.header = domCache.getHeader();
        c.html = domCache.getHtml();
        c.hasDataSection = !!domCache.get('div[data-section]');
        c.cssEm = typeof css_em !== 'undefined' ? css_em : 16;
        
        this.measureHeader();
        
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('touchmove', this.onScroll, { passive: true });
        
        c.lastScrollY = window.pageYOffset;
    },

    measureHeader() {
        const c = this.cache;
        const header = c.header;
        if (!header) return;
        
        c.headerHeight = header.offsetHeight;
        c.isAbsolutePosition = getComputedStyle(header).position === 'absolute';
        
        if (c.isAbsolutePosition) {
            if (!c.headerDiv) {
                c.headerDiv = domCache.get("header div");
            }
            c.headerDivHeight = c.headerDiv?.offsetHeight || 0;
        }
        
        c.headerHasDown = header.classList.contains("down");
        c.headerHasUp = header.classList.contains("up");
        c.htmlHasDown = c.html.classList.contains("down");
    },

    onScroll: (() => {
        return () => {
            const c = ScrollHandler.cache;
            if (c.ticking) return;
            c.ticking = true;
            requestAnimationFrame(ScrollHandler.updateScrollState);
        };
    })(),

    onResize: (() => {
        let t = null;
        return () => {
            if (t) clearTimeout(t);
            t = setTimeout(() => {
                ScrollHandler.measureHeader();
                
                if (moduleCache.has('mobil')) {
                    moduleCache.get('mobil').then(m => m.mobile_menu_init?.());
                }
                BreadcrumbManager.check();
            }, 150);
        };
    })(),

    updateScrollState() {
        const c = ScrollHandler.cache;
        const scrollY = window.pageYOffset;
        
        if (scrollY === c.lastScrollY) {
            c.ticking = false;
            return;
        }
        
        const header = c.header;
        const isDown = scrollY > c.lastScrollY;
        
        if (c.isAbsolutePosition) {
            const headerHeight = header.offsetHeight;
            const headerDivHeight = c.headerDivHeight;
            const cssEm = c.cssEm;
            
            if (isDown) {
                if (!c.headerHasDown) {
                    if (scrollY < headerHeight - headerDivHeight) {
                        header.classList.add("down");
                        header.classList.remove("up");
                        c.headerHasDown = true;
                        c.headerHasUp = false;
                        header.style.height = scrollY + headerDivHeight + cssEm + 'px';
                    } else if (scrollY > headerHeight) {
                        header.style.height = scrollY - cssEm + 'px';
                    }
                }
            } else {
                if (!c.headerHasUp && scrollY > headerHeight) {
                    header.classList.add("up");
                    header.classList.remove("down");
                    c.headerHasUp = true;
                    c.headerHasDown = false;
                    header.style.height = scrollY + 'px';
                } else if (scrollY + headerDivHeight < headerHeight) {
                    header.style.height = scrollY + headerDivHeight + cssEm + 'px';
                }
            }
        }
        
        const shouldBeDown = isDown && scrollY > c.headerHeight;
        if (shouldBeDown !== c.htmlHasDown) {
            c.html.classList.toggle("down", shouldBeDown);
            c.htmlHasDown = shouldBeDown;
        }
        
        if (!c.galaxyInitialized && scrollY > 200) {
            if (!c.galaxyElement) c.galaxyElement = domCache.get(".galaxy");
            if (c.galaxyElement && !c.galaxyElement.classList.contains("init")) {
                c.galaxyElement.classList.add("init");
                UIComponents.generateStars(c.galaxyElement);
                c.galaxyInitialized = true;
            }
        }
        
        if (c.hasDataSection) {
            NavigationManager.scrollSection();
        }
        
        c.lastScrollY = scrollY;
        c.ticking = false;
    },

    destroy() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('touchmove', this.onScroll);
    }
};

/**
 * ===================================================================
 * V. UI-Komponenten (Performance-optimiert)
 * ===================================================================
 */

const UIComponents = {
    showBannerRabatt(text) {
        const html = domCache.getHtml();
        if (html.classList.contains("banner_load")) return;

        const bannerElement = document.createElement("div");
        bannerElement.id = "banner_rabatt";
        bannerElement.innerHTML = `<div class='banner_rabatt_rabatt'>${text}</div>`;
        domCache.getBody().appendChild(bannerElement);

        // Micro-task statt setTimeout für bessere Performance
        Promise.resolve().then(() => html.classList.add("banner_load"));

        addUniqueEvent(bannerElement, 'click', () => {
            html.classList.remove("banner_load");
            setTimeout(() => bannerElement.remove(), 500);
        }, { name: 'bannerrabatt' });
    },

    toggleBannerHeaderRabatt() {
        const html = domCache.getHtml();
        const wasBannerVisible = html.classList.contains("banner_header_rabatt");
        const bannerText = wasBannerVisible ? "13% Rabatt" : "ausblenden";
        const shouldHideBanner = wasBannerVisible ? 1 : 0;

        html.classList.toggle("banner_header_rabatt", !wasBannerVisible);
        document.cookie = `banner_header_rabatt_hide=${shouldHideBanner}; path=/`;

        if (!wasBannerVisible && html.classList.contains("mobile_size")) {
            setTimeout(() => this.toggleBannerHeaderRabatt(), 15000);
        }

        const textElement = domCache.get("#banner_toggle_text");
        if (textElement) {
            textElement.innerHTML = bannerText;
        }

        setTimeout(() => window.dispatchEvent(new Event('scroll')), 300);
    },

    // Optimierte Star-Generierung mit DocumentFragment
    generateStars(galaxyContainer, starCount = 30) {
        const galaxyWidth = galaxyContainer.offsetWidth;
        const galaxyHeight = galaxyContainer.offsetHeight;

        if (galaxyWidth === 0 || galaxyHeight === 0) return;

        const fragment = document.createDocumentFragment();
        const stars = [];
        const delays = [];

        // Batch-Create alle Stars
        for (let i = 0; i < starCount; i++) {
            const star = document.createElement("div");
            star.className = `star star-type${Math.floor(Utils.getRandom(1, 4))}`;
            star.style.cssText = `top:${Utils.getRandom(0, galaxyHeight)}px;left:${Utils.getRandom(0, galaxyWidth)}px;opacity:0`;
            stars.push(star);
            fragment.appendChild(star);
            delays.push(Utils.getRandom(50, 2000));
        }
        
        galaxyContainer.appendChild(fragment);
        
        // Batch-Update aller Opacities
        delays.forEach((delay, i) => {
            setTimeout(() => {
                stars[i].style.opacity = '1';
                stars[i].style.transition = 'opacity 0.3s';
            }, delay);
        });
    },

    createBanner(message, buttonText, hreflang) {
        const banner = document.createElement("div");
        banner.className = "banner_ack country show";
        banner.innerHTML = `
            <div><div><div>
                <span><span><strong>Shop-Auswahl</strong>${message}</span></span>
                <span></span>
                <span class='button_light'>hier bleiben</span>
                <span class='button_red cookie'>${buttonText}</span>
            </div></div></div>
        `;
        domCache.getBody().appendChild(banner);
        
        // Event Delegation statt mehrere Listener
        banner.addEventListener('click', (e) => {
            if (e.target.classList.contains('button_light') || e.target.closest('.button_light')) {
                banner.remove();
            } else if (e.target.classList.contains('button_red') || e.target.closest('.button_red')) {
                banner.remove();
                const link = domCache.get(`link[rel=alternate][hreflang="${hreflang}"]`);
                if (link) window.location.href = link.getAttribute('href');
            }
        });
    }
};

/**
 * ===================================================================
 * OPTIMIERTER NAVIGATION MANAGER
 * - Gecachte Elemente
 * - Minimale DOM-Queries
 * - Effiziente Active-Section-Berechnung
 * ===================================================================
 */

const NavigationManager = {
    cache: {
        banner: null,
        bannerChecked: false,
        bannerVisible: false,
        navVisible: false,
        navigationSection: null,
        navItems: null,
        sections: null,
        sectionPositions: null,
        currentSelectedIndex: -1
    },

    /**
     * Banner-Sichtbarkeit prüfen (gecached)
     */
    isBannerVisible() {
        if (!this.cache.bannerChecked) {
            this.cache.banner = domCache.get("#banner_header_rabatt>div>div");
            this.cache.bannerChecked = true;
        }
        
        if (!this.cache.banner) return false;
        
        // getComputedStyle ist teuer - nur wenn Banner existiert
        return window.getComputedStyle(this.cache.banner).right === "0px";
    },

    /**
     * Section-Positionen pre-calculaten (bei Resize)
     */
    calculateSectionPositions() {
        const sections = domCache.getAll('div[data-section]');
        if (!sections.length) return null;
        
        const positions = [];
        const scrollY = window.scrollY;
        
        sections.forEach((section, index) => {
            const rect = section.getBoundingClientRect();
            positions.push({
                element: section,
                name: section.dataset.section,
                top: rect.top + scrollY,
                trigger: rect.top + scrollY + section.offsetHeight * 0.7
            });
        });
        
        this.cache.sectionPositions = positions;
        return positions;
    },

    /**
     * Haupt-Scroll-Funktion
     */
    scrollSection() {
        // Banner-Check nur einmal, dann gecached
        if (!this.cache.bannerVisible) {
            if (!this.isBannerVisible()) return;
            this.cache.bannerVisible = true;
        }
        
        // Navigation Section erstellen falls nötig (einmalig)
        if (!this.cache.navigationSection) {
            this.cache.navigationSection = domCache.get('#navigation_section');
            
            if (!this.cache.navigationSection) {
                const sections = domCache.getAll('div[data-section]');
                if (!sections.length) return;
                
                this.createNavigationSection(sections);
                this.cache.navigationSection = domCache.get('#navigation_section');
            }
            
            // Nav-Items + Sichtbarkeit einmalig cachen
            if (this.cache.navigationSection) {
                this.cache.navItems = this.cache.navigationSection.querySelectorAll('ul>li');
                this.cache.navVisible = window.getComputedStyle(this.cache.navigationSection).display !== 'none';
            }
        }
        
        // Gecachter Sichtbarkeits-Check
        if (!this.cache.navigationSection || !this.cache.navVisible) {
            return;
        }
        
        this.updateActiveSection();
    },
    
    
    
    
    

    /**
     * Navigation Section erstellen
     */
    createNavigationSection(sections) {
        const sitecontent = domCache.get("#sitecontent");
        if (!sitecontent) return;
        
        const navSection = document.createElement("div");
        navSection.id = "navigation_section";
        
        const ul = document.createElement("ul");
        const fragment = document.createDocumentFragment();
        const scrollY = window.scrollY;
        
        sections.forEach(section => {
            const rect = section.getBoundingClientRect();
            const li = document.createElement("li");
            
            li.innerHTML = `<ul><li></li><li>${section.dataset.section}</li></ul>`;
            li.dataset.posy = rect.top + scrollY + section.offsetHeight * 0.7;
            li.dataset.topy = rect.top + scrollY;
            
            // Click-Handler
            li.addEventListener('click', () => {
                window.scrollTo({
                    top: parseFloat(li.dataset.topy),
                    behavior: "smooth"
                });
            }, { passive: true });
            
            fragment.appendChild(li);
        });
        
        ul.appendChild(fragment);
        navSection.appendChild(ul);
        sitecontent.insertAdjacentElement("afterend", navSection);
        
        // Positions cachen
        this.calculateSectionPositions();
    },

    /**
     * Aktive Section updaten (optimiert)
     */
    updateActiveSection() {
        const navItems = this.cache.navItems;
        if (!navItems || !navItems.length) return;
        
        // Positions einmalig parsen und cachen
        if (!this.cache.parsedPositions) {
            this.cache.parsedPositions = Array.from(navItems).map(
                item => parseInt(item.dataset.posy, 10)
            );
        }
        
        const positions = this.cache.parsedPositions;
        const scrollY = window.scrollY;
        let newIndex = positions.length - 1;
        
        // Schnelle Schleife ohne parseInt
        for (let i = 0; i < positions.length; i++) {
            if (scrollY < positions[i]) {
                newIndex = i;
                break;
            }
        }
        
        // Nur DOM-Update wenn sich was geändert hat
        if (newIndex !== this.cache.currentSelectedIndex) {
            const oldIndex = this.cache.currentSelectedIndex;
            
            // Alte Selection entfernen
            if (oldIndex >= 0 && oldIndex < navItems.length) {
                navItems[oldIndex].classList.remove("selected");
            }
            
            // Neue Selection setzen
            navItems[newIndex].classList.add("selected");
            this.cache.currentSelectedIndex = newIndex;
        }
    },

    /**
     * Cache invalidieren (bei AJAX-Load)
     */
    invalidate() {
        this.cache.navigationSection = null;
        this.cache.navItems = null;
        this.cache.sectionPositions = null;
        this.cache.parsedPositions = null;
        this.cache.currentSelectedIndex = -1;
        this.cache.bannerChecked = false;
        this.cache.bannerVisible = false;
        this.cache.navVisible = false;
    }
};


/**
 * ===================================================================
 * OPTIMIERTER BREADCRUMB MANAGER
 * - Kein Layout Thrashing
 * - RAF-basiertes Batching
 * - Minimale Reflows
 * ===================================================================
 */

const BreadcrumbManager = {
    pending: false,

    getLineMetrics(breadcrumbList) {
        const breadcrumb = breadcrumbList.closest("#breadcrump");
        const listRect = breadcrumbList.getBoundingClientRect();
        let availableWidth = breadcrumbList.clientWidth;
        const scope = breadcrumb?.parentElement || document;
        const blockers = scope.querySelectorAll(".content_star");
        let targetRight = listRect.left + availableWidth;

        blockers.forEach(blocker => {
            const blockerRect = blocker.getBoundingClientRect();
            const overlapsLine = blockerRect.width > 0 &&
                blockerRect.height > 0 &&
                blockerRect.left > listRect.left &&
                blockerRect.top < listRect.bottom &&
                blockerRect.bottom > listRect.top;

            if (overlapsLine) {
                availableWidth = Math.min(availableWidth, Math.max(0, blockerRect.left - listRect.left - 8));
                targetRight = Math.min(targetRight, blockerRect.left - 8);
            }
        });

        return {
            availableWidth,
            hasBlocker: availableWidth < breadcrumbList.clientWidth - 0.5,
            targetRight
        };
    },

    getVisibleRight(items) {
        let right = 0;
        for (let i = 0; i < items.length; i++) {
            if (items[i].classList.contains('none')) continue;
            right = Math.max(right, items[i].getBoundingClientRect().right);
        }

        return right;
    },
    
    check() {
        if (this.pending) return;
        this.pending = true;
        
        requestAnimationFrame(this._doCheck);
    },
    
    _doCheck() {
        BreadcrumbManager.pending = false;

        const breadcrumbList = domCache.get("#breadcrump > ul");
        if (!breadcrumbList) return;

        const breadcrumb = breadcrumbList.closest("#breadcrump");
        breadcrumb?.classList.add("check");

        const items = breadcrumbList.children;
        const len = items.length;
        if (len < 3) return;

        // In einem Frame messen und anwenden, damit es keinen sichtbaren
        // Zwischenzustand mit allen Breadcrumb-Ebenen gibt.
        breadcrumbList.classList.remove("overflow");
        for (let i = 1; i < len - 1; i++) {
            items[i].classList.remove('none');
        }

        const metrics = BreadcrumbManager.getLineMetrics(breadcrumbList);
        const containerWidth = metrics.availableWidth;

        const widths = new Float32Array(len);
        let contentWidth = 0;
        for (let i = 0; i < len; i++) {
            widths[i] = items[i].getBoundingClientRect().width;
            contentWidth += widths[i];
        }

        let remaining = contentWidth;
        const needsMoreCollapse = () => {
            if (metrics.hasBlocker) {
                return BreadcrumbManager.getVisibleRight(items) > metrics.targetRight + 0.5;
            }

            return remaining > containerWidth;
        };

        if (!needsMoreCollapse()) return;

        let overflowMeasured = false;
        const enableOverflow = () => {
            if (overflowMeasured) return;
            breadcrumbList.classList.add("overflow");

            const overflowDelta = items[0].getBoundingClientRect().width - widths[0];
            if (overflowDelta > 0) remaining += overflowDelta;
            overflowMeasured = true;
        };

        for (let i = 1; i < len - 1 && needsMoreCollapse(); i++) {
            enableOverflow();
            remaining -= widths[i];
            items[i].classList.add('none');
        }
    }
};


/**
 * ===================================================================
 * VIII. Title Animation (Performance-optimiert)
 * ===================================================================
 */

const TitleAnimation = {
    config: {
        speed: 1000,
        text: " • jetzt bei slewo.com bestellen! ",
        pauseDuration: 5000
    },

    state: {
        originalTitle: "",
        scrollText: "",
        tabInterval: null,
        isPaused: false
    },

    updateTitle() {
        if (this.state.isPaused) return;

        // String-Operation optimiert
        this.state.scrollText = this.state.scrollText.slice(1) + this.state.scrollText[0];
        document.title = this.state.scrollText;

        if (this.state.scrollText.endsWith(this.config.text)) {
            this.state.isPaused = true;
            setTimeout(() => {
                if (!document.hidden) return;
                this.state.scrollText = this.state.originalTitle + this.config.text;
                this.state.isPaused = false;
            }, this.config.pauseDuration);
        }
    },

    handleVisibilityChange() {
        if (document.hidden) {
            if (this.state.tabInterval) return;
            
            this.state.originalTitle = document.title;
            this.state.scrollText = this.state.originalTitle + this.config.text;
            this.state.isPaused = false;
            this.state.tabInterval = setInterval(() => this.updateTitle(), this.config.speed);
        } else {
            if (this.state.tabInterval) {
                clearInterval(this.state.tabInterval);
                this.state.tabInterval = null;
            }
            document.title = this.state.originalTitle;
        }
    },

    start() {
        if (typeof document.hidden !== "undefined") {
            document.addEventListener("visibilitychange", () => this.handleVisibilityChange(), { passive: true });
        }
    }
};

/**
 * ===================================================================
 * IX. Reviews Manager
 * ===================================================================
 */

const ReviewsManager = {
    init() {
        const d = domCache.get('#content_bewertungen_mehr');
        if (!d?.dataset.pos) return;
        
        const data = {
            anr: d.dataset.anr,
            pos: d.dataset.pos,
            limit: d.dataset.limit
        };
        
        addUniqueEvent(d, 'click', function() {
            this.style.pointerEvents = 'none';
            this.innerHTML = '';
            this.classList.add('loader');
            
            ajax({
                url: "/bewertungen.ajax",
                data
            }).then(response => {
                if (!response) return;
                
                this.remove();
                
                const container = domCache.get("#content_bewertungen");
                if (!container) return;
                
                // Temporäres Element zum Parsen
                const temp = document.createElement('div');
                temp.innerHTML = response;
                
                const newElements = Array.from(temp.children);
                let transitionCount = 0;
                
                // Alle Elemente vorbereiten und einfügen
                newElements.forEach(element => {
                    element.style.cssText = `
                        max-height: 0;
                        overflow: hidden;
                        transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
                    `;
                    
                    // TransitionEnd Listener für Cleanup
                    element.addEventListener('transitionend', function cleanup(e) {
                        if (e.propertyName === 'max-height') {
                            this.style.maxHeight = '';
                            this.style.overflow = '';
                            this.style.transition = '';
                            this.removeEventListener('transitionend', cleanup);
                            
                            // Zähler für letztes Element
                            transitionCount++;
                            if (transitionCount === newElements.length) {
                                domCache.invalidate('#content_bewertungen_mehr');
                                ReviewsManager.init();
                            }
                        }
                    }, { passive: true });
                    
                    container.appendChild(element);
                });
                
                // Animation starten
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        newElements.forEach(element => {
                            const height = element.scrollHeight;
                            element.style.maxHeight = `${height}px`;
                        });
                    });
                });
                
            }).catch(error => {
                console.error('Fehler beim Laden der Bewertungen:', error);
                this.style.pointerEvents = '';
                this.innerHTML = 'Weitere Bewertungen laden';
                this.classList.remove('loader');
            });
        }, { name: 'click_bewertung' });
    }
};
/**
 * ===================================================================
 * X. Jobs Manager
 * ===================================================================
 */

const JobsManager = {
    init() {
        const clickHandler = function() {
            const parentLi = this.parentNode;
            domCache.getAllArray(".info_opener li").forEach(li => li.classList.remove("open"));
            if (!parentLi.classList.contains("open")) {
                parentLi.classList.add("open");
            }
        };
        addUniqueEvent(domCache.getAll(".info_opener li h3"), "click", clickHandler);
    }
};

/**
 * ===================================================================
 * XI. Livesearch Manager
 * ===================================================================
 */

window.livesearch_unload = function() {
    domCache.get(".suche input[type=search]")?.blur();
    
    const container2 = domCache.get(".livesearch.init");

    if (container2 && !window.zoom_history) {
        window.history.back();
    }
    window.zoom_history = null;
    
    domCache.getAllArray(".livesearch").forEach(element => {
        element.classList.remove("init");
    });
    domCache.getHtml().classList.remove("load_suche");
};

/**
 * ===================================================================
 * XII. Basket Manager (Performance-optimiert)
 * ===================================================================
 */

const BasketManager = {
    observer: null,
    visCheck: true,
    visFooter: false,
    artikelEl: null,
    isShown: false,

    initArtikelBasket() {
        const contentElement = domCache.get('#content_artikel_basket_basket');
        let artikelElement = domCache.get('#artikel_to_basket');
        
        if (contentElement) {
            const preisElement = domCache.get('#content_artikel_basket_basket .kauf_preis .preis_normal');
            const versandElement = domCache.get('#content_artikel_basket_basket .content_artikel_versand>a');
            
            if (preisElement && versandElement) {
                const preisText = preisElement.innerText.trim().replace(/[^\d,.-]/g, '').replace(',', '.');
                const preis = parseFloat(preisText).toFixed(2).replace('.', ',');
                const vorkassePreis = (parseFloat(preisText) * 0.97).toFixed(2).replace('.', ',');
                const [preisEuro, preisCent] = preis.split(',');
                const [vorkasseEuro, vorkasseCent] = vorkassePreis.split(',');
                const preisClass = preisElement.classList.contains('ab') ? 'preis_normal ab' : 'preis_normal';
                
                if (!artikelElement) {
                    artikelElement = document.createElement('div');
                    artikelElement.id = 'artikel_to_basket';
                    domCache.getBody().appendChild(artikelElement);
                    domCache.invalidate('#artikel_to_basket');
                }
                
                this.artikelEl = artikelElement;
                // Immer ausgeblendet starten
                this.isShown = false;
                artikelElement.classList.remove('show');
                
                // a11y: <div role="button" tabindex="0"> statt nacktem <div> — Tab-fokussierbar
                // und Screenreader-erkannt, OHNE das CSS des urspruenglichen Buttons zu zerschiessen.
                // Keyboard-Handler unten triggert click bei Enter/Space.
                artikelElement.innerHTML = `<div><div><div><div class="${preisClass}" style="display: block">${preisEuro}.<sup>${preisCent}</sup></div><span>${versandElement.textContent.trim()}</span></div><div><div class="${preisClass}">${vorkasseEuro}.<sup>${vorkasseCent}</sup></div><span>bei Vorkasse</span></div><div id="warenkorb_btn" role="button" tabindex="0" aria-label="In den Warenkorb">in den Warenkorb</div></div><div><div id="sale_btn" role="button" tabindex="0" aria-label="13% Warenkorbrabatt anwenden">+ 13% Warenkorbrabatt</div></div></div>`;

                const warenkorbBtn = domCache.get('#warenkorb_btn');
                const triggerCart = function() {
                    // Klick auf den Kaufknopf, nicht auf den Kasten: der Kasten
                    // hoert seit dem Umbau nicht mehr zu.
                    (contentElement.querySelector('.kauf_cta') || contentElement).click();
                    domCache.get('#content_artikel>div:first-child>div:nth-child(2)')?.scrollIntoView({
                        behavior: 'smooth'
                    });
                };
                addUniqueEvent(warenkorbBtn, 'click', triggerCart, { name: 'click_warenkorb' });
                addUniqueEvent(warenkorbBtn, 'keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); triggerCart(); }
                }, { name: 'kbd_warenkorb' });

                const saleBtn = domCache.get('#sale_btn');
                const triggerSale = () => domCache.get('#banner_header_rabatt .button_red')?.click();
                addUniqueEvent(saleBtn, 'click', triggerSale, { name: 'click_sale' });
                addUniqueEvent(saleBtn, 'keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); triggerSale(); }
                }, { name: 'kbd_sale' });
                
                const checkElement = domCache.get('#content_artikel>div:first-child>div:nth-child(2)>div:nth-child(2)');
                const footerEl = domCache.get('footer');
                
                if (checkElement && footerEl) {
                    if (this.observer) this.observer.disconnect();
                    
                    this.visCheck = true;
                    this.visFooter = false;
                    
                    const self = this;
                    let initialized = false;
                    
                    this.observer = new IntersectionObserver(function(entries) {
                        for (let i = 0, len = entries.length; i < len; i++) {
                            const e = entries[i];
                            if (e.target === checkElement) {
                                self.visCheck = e.isIntersecting;
                            } else {
                                self.visFooter = e.isIntersecting;
                            }
                        }
                        
                        const shouldShow = !self.visCheck && !self.visFooter;
                        
                        // Beim ersten Callback den echten Layout-Zustand nachziehen.
                        if (!initialized) {
                            initialized = true;
                            if (shouldShow) {
                                requestAnimationFrame(function() {
                                    if (!self.visCheck && !self.visFooter) {
                                        self.isShown = true;
                                        self.artikelEl.classList.add('show');
                                    }
                                });
                            }
                            return;
                        }
                        
                        if (shouldShow !== self.isShown) {
                            self.isShown = shouldShow;
                            self.artikelEl.classList.toggle('show', shouldShow);
                        }
                    }, { threshold: 0 });
                    
                    this.observer.observe(checkElement);
                    this.observer.observe(footerEl);
                }
            }
        } else if (artikelElement) {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
            artikelElement.remove();
            domCache.invalidate('#artikel_to_basket');
            this.artikelEl = null;
        }
    }
};
/**
 * ===================================================================
 * XIII. Filter Manager (Performance-optimiert)
 * ===================================================================
 */

const FilterManager = {
    initMobileFilter() {
        const filter = domCache.get(".content_usicht_filter");
        const html = domCache.getHtml();
        
        if (!filter || !html.classList.contains('mobile')) return;

        if (!domCache.get("#content_usicht_filter_mobil")) {
            domCache.getBody().insertAdjacentHTML("beforeend", 
                "<div id='content_usicht_filter_mobil'><div></div><div><div></div><div></div></div><div></div></div>"
            );
            
            setTimeout(() => domCache.get("#content_usicht_filter_mobil")?.classList.add("load"), 500);
            
            // Event Delegation
            const mobilFilter = domCache.get("#content_usicht_filter_mobil");
            mobilFilter?.addEventListener('click', (e) => {
                if (e.target === mobilFilter.firstElementChild || e.target.closest('div:first-child')) {
                    domCache.get("#filterbox")?.classList.add("show");
                } else if (e.target === mobilFilter.children[1] || e.target.closest('div:nth-child(2)')) {
                    if (domCache.get(".content_usicht_visible")) {
                        domCache.get("#content_usicht_grid")?.click();
                    }
                }
            }, { passive: true });
            
            domCache.invalidate("#content_usicht_filter_mobil");
        }
        
        if (!domCache.get("#filterbox")) {
            const modifiedContent = filter.innerHTML
                .replace(/id="([^"]+)"/g, (_, id) => `id="${id}_copy"`)
                .replace(/for="([^"]+)"/g, (_, id) => `for="${id}_copy"`);
            
            domCache.getBody().insertAdjacentHTML("beforeend", 
                `<div id='filterbox'><div></div><div class='content_usicht_filter'>${modifiedContent}</div></div>`
            );
            
            // Event Delegation
            const filterbox = domCache.get("#filterbox");
            filterbox?.addEventListener('click', (e) => {
                if (e.target === filterbox.firstElementChild) {
                    filterbox.classList.remove("show");
                }
            }, { passive: true });
            
            domCache.invalidate("#filterbox");
        }
    }
};

/**
 * ===================================================================
 * XIV. Observer Manager (Performance-optimiert)
 * ===================================================================
 */

const ObserverManager = {
    // Gecachte Referenzen
    _html: null,
    _body: null,
    
    // Lazy getter
    getHtml() {
        return this._html || (this._html = domCache.getHtml());
    },
    
    getBody() {
        return this._body || (this._body = domCache.getBody());
    },

    initContentUsichtObserver() {
        const target = domCache.get('.content_usicht > ul:not(.content_usicht_banner_box)');
        if (!target) return;

        if (!STATE.observers.bannerBox) {
            const html = this.getHtml();
            let isVisible = html.classList.contains("content_usicht_visible");
            
            STATE.observers.bannerBox = new IntersectionObserver(function(entries) {
                const nowVisible = entries[0].isIntersecting;
                if (nowVisible !== isVisible) {
                    isVisible = nowVisible;
                    html.classList.toggle("content_usicht_visible", nowVisible);
                }
            }, { threshold: 0 });
        }
        
        STATE.observers.bannerBox.observe(target);
    },

    initPageButtonObservers() {
        const pageButtons = domCache.getAllArray(".content_usicht_page_button");
        const len = pageButtons.length;
        if (!len) return;
        
        const counters = STATE.counters;
        const observerMap = STATE.observers.usichtPage;
        
        for (let i = 0; i < len; i++) {
            const pageButton = pageButtons[i];
            
            if (observerMap.has(pageButton)) continue;
            
            const observer = new IntersectionObserver(function(entries, obs) {
                if (!entries[0].isIntersecting) return;
                if (counters.usichtPage >= 3) return;
                
                const aElement = entries[0].target.querySelector("a");
                if (aElement) {
                    const virtualClick = new MouseEvent("click", {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
                    virtualClick.isVirtualClick = true;
                    aElement.dispatchEvent(virtualClick);
                    counters.usichtPage++;
                }
                
                obs.unobserve(entries[0].target);
            }, { threshold: 0 });
            
            observer.observe(pageButton);
            observerMap.set(pageButton, observer);
        }
    },

    initGridObservers() {
        const usichtContents = domCache.getAllArray("div:not(#content_usicht_home)>#content_usicht>ul");
        const len = usichtContents.length;
        
        const html = this.getHtml();
        
        if (!len) {
            html.classList.remove("content_usicht_grid");
            return;
        }
        
        const body = this.getBody();
        const observerMap = STATE.observers.contentUsicht;
        
        // Grid HTML einmalig erstellen
        const gridHTML = "<ul><li></li><li></li></ul><ul><li></li><li></li><li></li></ul>";
        
        for (let i = 0; i < len; i++) {
            const usichtContent = usichtContents[i];
            
            if (observerMap.has(usichtContent)) continue;
            
            const observer = new IntersectionObserver(function(entries, obs) {
                if (entries[0].isIntersecting) {
                    let grid = domCache.get("#content_usicht_grid");
                    
                    if (!grid) {
                        grid = document.createElement("div");
                        grid.id = "content_usicht_grid";
                        grid.innerHTML = gridHTML;
                        body.appendChild(grid);
                        
                        grid.onclick = function() {
                            const hasZoom = html.classList.toggle("usicht_zoom");
                            ajax({
                                url: "/save.ajax",
                                data: {
                                    shop: '{"usicht_zoom":' + (hasZoom ? 1 : 0) + '}'
                                }
                            });
                            window.dispatchEvent(new Event('resize'));
                        };
                        
                        domCache.invalidate('#content_usicht_grid');
                    }
                    
                    setTimeout(function() {
                        html.classList.add("content_usicht_grid");
                    }, 100);
                    
                    obs.unobserve(usichtContent);
                    observerMap.delete(usichtContent);
                } else {
                    html.classList.remove("content_usicht_grid");
                }
            }, { 
                rootMargin: '15% 0px 15% 0px',
                threshold: 0
            });
            
            observer.observe(usichtContent);
            observerMap.set(usichtContent, observer);
        }
    },
    
    // Reset bei SPA-Navigation
    reset() {
        this._html = null;
        this._body = null;
    }
};

/**
 * ===================================================================
 * XV. Input Validation Manager (Performance-optimiert)
 * ===================================================================
 */

const InputValidation = {
    // Compiled RegEx für bessere Performance
    filters: {
        tel: /^(?:[+0])?$|^[+0][0-9]*[/-]?[0-9]*[-]?[0-9]*$/i,
        str2: /^[a-z0-9 \-/]{0,6}$/i,
        plz: /^[a-z0-9]{0,6}$/i,
        preis: /^-?\d*[.,]?\d{0,2}$/i,
        email: /^[a-z0-9._-]*(?:@[a-z0-9_-]*(?:\.[a-z0-9_-]*)?)?$/i,
        iban: /^(?:[a-z]{0,2})?$|^[a-z]{2}[0-9 ]*$/i,
        slewonumber: /^(?:1?0?0?)?$|^100[0-9]{0,6}$/i,
        number: /^[0-9]*$/i
    },

    createFilter(regex) {
        return (e) => {
            const value = e.target.value;
            if (regex.test(value)) return;
            
            // Optimierte Filterung
            const filtered = Array.from(value).filter(c => regex.test(c)).join('');
            let newValue = filtered;
            
            while (newValue.length > 0 && !regex.test(newValue)) {
                newValue = newValue.slice(0, -1);
            }
            
            if (e.target.value !== newValue) {
                e.target.value = newValue;
            }
        };
    },

    init() {
        const filterMap = {
            ".input_check_tel": this.filters.tel,
            ".input_check_str2": this.filters.str2,
            ".input_check_plz": this.filters.plz,
            ".input_check_preis": this.filters.preis,
            ".input_check_email": this.filters.email,
            ".input_check_iban": this.filters.iban,
            ".input_check_slewonumber": this.filters.slewonumber,
            ".input_check_number": this.filters.number
        };

        Object.entries(filterMap).forEach(([selector, filter]) => {
            domCache.getAllArray(selector).forEach(el => {
                el.addEventListener("input", this.createFilter(filter), { passive: true });
            });
        });
    }
};

/**
 * ===================================================================
 * XVI. Password Manager (Performance-optimiert)
 * ===================================================================
 */

const PasswordManager = {
    // Compiled RegEx
    patterns: {
        length: /.{8,}/,
        mixedCase: /(?:[a-z].*[A-Z])|(?:[A-Z].*[a-z])/,
        alphanumeric: /(?=.*[a-zA-Z])(?=.*[0-9])/,
        special: /[!,%,&,@,#,$,^,*,?,_,~]/,
        doubleSpecial: /.*[!,%,&,@,#,$,^,*,?,_,~].*[!,%,&,@,#,$,^,*,?,_,~]/
    },

    strengthClasses: ["strength1", "strength2", "strength3", "strength4", "strength5", "error_pw"],

    checkStrength(el) {
        const fieldset = el.closest("fieldset");
        const info = fieldset.querySelector(".info");
        
        fieldset.classList.remove(...this.strengthClasses);
        info?.remove();

        const value = el.value;
        
        if (value.length < 6) {
            el.dataset.strength = 0;
            const strengthInput = domCache.get("#password_strength");
            if (strengthInput) strengthInput.value = 0;
            return;
        }

        // Optimierte Strength-Berechnung
        const strength = [
            this.patterns.length.test(value),
            this.patterns.mixedCase.test(value),
            this.patterns.alphanumeric.test(value),
            this.patterns.special.test(value),
            this.patterns.doubleSpecial.test(value)
        ].reduce((acc, curr) => acc + curr, 0);
        
        el.dataset.strength = strength;
        const strengthInput = domCache.get("#password_strength");
        if (strengthInput) strengthInput.value = strength;

        // Batch Class-Addition
        const classesToAdd = this.strengthClasses.slice(0, strength);
        if (classesToAdd.length) {
            fieldset.classList.add(...classesToAdd);
        }
    },

    init() {
        const strengthInputs = domCache.getAllArray(".password_strength input");
        const checkInputs = domCache.getAllArray(".password_check");
        const allPasswordInputs = domCache.getAllArray(".password_check, .password_strength input");

        strengthInputs.forEach(input => {
            input.addEventListener("keyup", () => this.checkStrength(input), { passive: true });
            
            input.addEventListener("blur", function() {
                this.type = "password";
                if (this.dataset.strength < 2) {
                    const fieldset = this.closest("fieldset");
                    fieldset.insertAdjacentHTML("beforeend", 
                        "<div class='info'>Das eingegebene Passwort ist zu schwach!<br />Das Passwort muss mindestens 6 zeichen lang sein und sollte Buchstaben, Zahlen und Sonderzeichen enthalten.</div>"
                    );
                    fieldset.classList.add("error");
                }
            });
        });
        
        checkInputs.forEach(input => {
            input.addEventListener("blur", function() {
                this.type = "password";
                const newPw1 = domCache.get("#new_pw1");
                if (newPw1 && this.value != newPw1.value) {
                    const fieldset = this.closest("fieldset");
                    fieldset.insertAdjacentHTML("beforeend", 
                        "<div class='info'>Die Passwörter stimmen nicht überein! Bitte versuchen Sie es erneut.</div>"
                    );
                    fieldset.classList.add("error");
                }
            });
        });
        
        allPasswordInputs.forEach(input => {
            input.addEventListener("focus", function() {
                this.type = "text";
            }, { passive: true });
        });
    }
};




/**
 * ===================================================================
 * XVII. Event Handlers Collection (Performance-optimiert)
 * ===================================================================
 */
/**
 * ===================================================================
 * XVII. Event Handlers Collection (Performance-optimiert)
 * OHNE overwrite: true - EventService erkennt neue Elemente automatisch
 * ===================================================================
 */

const EventHandlers = {
    // ===================================================================
    // EINMALIGE EVENTS (nur bei init2, bleiben im DOM)
    // ===================================================================
    
    initBasicEvents() {
        const html = domCache.getHtml();
        
        document.addEventListener('dragstart', e => e.preventDefault());
        // Eingabeart dauerhaft nachfuehren statt einmalig raten.
        //
        // Vorher standen hier zwei Listener mit { once: true }. Das war aus
        // zwei Gruenden falsch. Erstens schiebt die Maus-Kompatibilitaets-
        // kette nach JEDER Beruehrung ein mousemove nach: Der erste Tap auf
        // einem Handy setzte damit dauerhaft 'mouse', und daran haengen die
        // :hover-Regeln in style.css (Zoom auf 118 %, Zeile 2160-2169), die
        // danach am getippten Element kleben blieben. Zweitens war der
        // touchstart-Listener zu diesem Zeitpunkt schon verbraucht, es gab
        // also keinen Weg zurueck - ein Touch-Notebook blieb bis zum
        // Neuladen im falschen Zustand.
        //
        // Pointer Events nennen die Eingabeart selbst (pointerType) und
        // lassen sich deshalb beliebig oft auswerten. Auf welche davon
        // gehoert wird und warum, steht unten bei der Registrierung - es
        // sind fuenf, und jedes deckt eine eigene Luecke.
        if (window.PointerEvent) {
            // Die Maus-Kompatibilitaetskette reicht bis in die Pointer
            // Events hinein: Nach jeder Beruehrung schiebt der Browser
            // synthetische Maus-Ereignisse nach. Gemessen am 2026-09-21
            // ueber CDP ist die Folge eines einzelnen Taps
            //
            //   pointerover:touch, pointerdown:touch, touchstart,
            //   mousemove, pointerover:MOUSE
            //
            // - das letzte Ereignis wuerde den Zustand sofort wieder auf
            // 'mouse' ziehen. Genau daran scheiterte schon die alte
            // Fassung mit { once: true }; sie nur auf Pointer Events
            // umzustellen, wiederholt den Fehler eine Ebene hoeher.
            // Deshalb eine Sperre: kurz nach einer Beruehrung gilt kein
            // Maus-Ereignis. Eine echte Maus meldet sich danach ohnehin
            // wieder.
            const NACH_BERUEHRUNG_MS = 500;
            let letzteBeruehrung = -Infinity;

            const eingabeart = e => {
                const art = e.pointerType;

                // Der haeufigste Fall zuerst und ohne weitere Arbeit: es
                // stimmt schon. Das laeuft bei jeder Mausbewegung, deshalb
                // steht es ganz vorne - ein Zeichenkettenvergleich.
                if (html.classList.contains(art)) {
                    if (art === 'touch') letzteBeruehrung = performance.now();
                    return;
                }

                // Nur Finger und Maus entscheiden. Ein Stift sagt nichts
                // darueber, ob es Hover gibt: auf einem Surface schon, auf
                // einem Tablet nicht. Er laesst den Zustand deshalb, wie er
                // ist, statt ihn zu raten.
                if (art === 'touch') {
                    letzteBeruehrung = performance.now();
                } else if (art === 'mouse') {
                    // performance.now() statt e.timeStamp: Bei echten
                    // Ereignissen liegen beide auf derselben Achse, das ist
                    // Standard. Bei eingespeisten - Automation, Fernsteuerung,
                    // Erweiterungen - nicht: ueber CDP gemessen lagen Touch
                    // und Mausbewegung 303 ms auseinander, womit die Differenz
                    // bedeutungslos wird. Eine im Handler abgelesene Uhr ist
                    // unabhaengig davon, wer das Ereignis erzeugt hat.
                    if (performance.now() - letzteBeruehrung < NACH_BERUEHRUNG_MS) return;
                } else {
                    return;
                }

                html.classList.remove('mouse', 'touch');
                html.classList.add(art);
            };

            // Fuenf Ereignisse, und jedes deckt eine eigene Luecke:
            //
            //   pointerdown/pointerover  der Anfang einer Geste.
            //   pointermove              Wer nach einer Beruehrung die Maus
            //                            bewegt, ohne ein anderes Element zu
            //                            ueberqueren, erzeugt WEDER
            //                            pointerdown NOCH pointerover und
            //                            bliebe sonst dauerhaft auf 'touch'.
            //   pointerup/pointercancel  das ENDE der Geste - der eigentlich
            //                            entscheidende Stempel.
            //
            // Die letzten beiden tragen die Sperre. Die synthetische
            // Maus-Kette kommt NACH dem Loslassen; wird nur der Anfang
            // gestempelt, ist die Sperre bei jedem Druck abgelaufen, der
            // laenger dauert als sie selbst - Langdruck aufs Bild, langsamer
            // Tap, oder ein Finger, der vor dem Wischen kurz stillsteht.
            // Auf pointermove ist dabei kein Verlass: Uebernimmt der Browser
            // die Geste als Scroll, schickt er pointercancel und stellt
            // pointermove fuer diesen Zeiger ein.
            //
            // Der Kurzschluss oben haelt die Kosten bei einem Vergleich pro
            // Ereignis; up und cancel fallen dort hinein und stempeln, ohne
            // eine weitere Zeile Logik zu brauchen.
            addEventListener('pointerdown', eingabeart, { passive: true });
            addEventListener('pointerover', eingabeart, { passive: true });
            addEventListener('pointermove', eingabeart, { passive: true });
            addEventListener('pointerup', eingabeart, { passive: true });
            addEventListener('pointercancel', eingabeart, { passive: true });
        } else {
            addEventListener('touchstart', () => html.classList.replace('mouse', 'touch'), { once: true, passive: true });
            addEventListener('mousemove', () => html.classList.replace('touch', 'mouse'), { once: true, passive: true });
        }

        document.addEventListener('click', function(e) {
            const target = e.target;
            
            if (!target.classList.contains('outside') && !target.closest('.outside')) {
                domCache.getAllArray(".outside.selected").forEach(el => el.classList.remove("outside", "selected"));
            }
            
            if (!target.classList.contains('content_usicht_filter') && !target.closest('.content_usicht_filter')) {
                domCache.get(".content_usicht_filter .active>div>div>div:first-child")?.click();
            }
        }, { passive: true });
    },

    initFooterObserver() {
        const footerElement = domCache.get('footer');
        const html = domCache.getHtml();
        
        if (footerElement) {
            const observer = new IntersectionObserver(entries => {
                html.classList.toggle("footer_visible", entries[0].isIntersecting);
            }, { 
                threshold: 0,
                rootMargin: '0px'
            });
            observer.observe(footerElement);
        }
    },

    initApplePay() {
        const html = domCache.getHtml();
        
        if (!html.classList.contains('applepay_check')) {
            html.classList.add('applepay_check');
            ajax({
                url: "/save.ajax",
                data: {
                    shop: JSON.stringify({
                        applepay_check: 1,
                        applepay_available: window.ApplePaySession ? 1 : 0
                    })
                }
            });
        }
    },

    initSearchEvents() {
        if (!domCache.get("header>div>div:nth-child(3)>span")) livesearch_init();
        
        addUniqueEvent(domCache.getAll("#sitecontent .suche"), 'submit', function(e) {
            e.preventDefault();
            this.querySelector("input").blur();
            getlink("/search/?q=" + this.querySelector("input").value);
        }, { name: 'submit_search' });
    },

    initNavigationEvents() {
        addUniqueEvent(domCache.getAll("a.hearty"), 'click', function(e) {
            e.preventDefault();
            if (!domCache.get(".load_suche")) getlink(this.href);
            else livesearch_unload();
        }, { name: 'click_hearty' });
        
        const html = domCache.getHtml();
        addUniqueEvent(domCache.getAll("header nav>ul>li a"), 'click', function(e) {
            e.preventDefault();
            if (this.parentElement.classList.contains("home")) {
                window.scroll_to_top = 1;
                getlink(this.href);
            }
            if (this.parentElement.classList.contains("hearty") && html.classList.contains("hearty")) {
                getlink(this.href);
            }
            if (domCache.get(".mobile_size")) mobile_menu_load = 1;
            getlink(this.href);
        }, { name: 'click_nav' });
    },

    initBannerEvents() {
        addUniqueEvent(domCache.get("#banner_header_rabatt .button_red"), "click", () => 
            ajax({ url: "/banner.ajax", data: "id=sale" }).then(r => UIComponents.showBannerRabatt(r))
        , { name: 'click_banner_red' });
        
        addUniqueEvent(domCache.get("#banner_header_rabatt>div>div"), "click", () => 
            UIComponents.toggleBannerHeaderRabatt()
        , { name: 'click_banner' });
        
        addUniqueEvent(domCache.getAll(".banner_ack .close"), 'click', () => 
            domCache.get(".banner_ack")?.remove()
        , { name: 'click_banner_close' });
    },

    initShopSelectEvents() {
        addUniqueEvent(domCache.getAll(".shop_select"), "click", function() {
            this.classList.add("selected");
            const json = { taxfree: this.dataset.taxfree || "unset" };
            ajax({
                url: "/save.ajax",
                data: { shop: JSON.stringify(json) }
            }).then(() => location.reload());
        }, { name: 'click_select_shop' });
    },

    initRatingEvents() {
        addUniqueEvent(domCache.getAll(".content_star_set"), "click", function(e) {
            this.classList.remove("error", "content_star0", "content_star1", "content_star2", "content_star3", "content_star4", "content_star5");
            const w = this.offsetWidth;
            const relX = e.clientX - this.getBoundingClientRect().left;  // clientX statt pageX
            const c = Math.ceil((relX / w) * 5);
            this.classList.add("content_star" + c);
            this.querySelector("input").value = c;
            domCache.get("button.button_red")?.removeAttribute('disabled');
        }, { name: 'click_rating' });
    },

    initNewsletterEvents() {
        addUniqueEvent(domCache.getAll(".newsletter .more"), "click", function() {
            this.closest(".newsletter").classList.add("load");
        }, { name: 'click_newsletter_more' });
        
        const newsletterBtns = domCache.getAll(".newsletter input[type='button']");
        if (newsletterBtns.length > 0) {
            addUniqueEvent(newsletterBtns[0], 'click', function() {
                ensureCaptchaValidation().then(() => {
                    ajax({
                        url: "/newsletter.ajax?do=add",
                        data: { email: domCache.get("#newsletter")?.value },
                        cache: false,
                        dataType: "json"
                    }).then(r => {
                        if (r.error) {
                            const info = document.createElement("div");
                            info.className = "info";
                            info.textContent = r.error;
                            domCache.get(".newsletter label")?.insertAdjacentElement("afterend", info);
                        } else {
                            const tableFormular = domCache.get(".newsletter .table_formular");
                            if (tableFormular) tableFormular.innerHTML = r.ok;
                        }
                    });
                }).catch(err => console.error("Captcha validation failed:", err));
            }, { name: 'click_newsletter_add' });
        }
    },

    initCaptchaEvents() {
        addUniqueEvent(domCache.getAll(".captcha_check_form"), 'submit', function(e) {
            e.preventDefault();
            const currentForm = this;
            ensureCaptchaValidation()
                .then(() => currentForm.submit())
                .catch(err => console.error("Captcha validation failed:", err));
        }, { name: 'click_captcha_submit' });
    },

    initBasketRightEvents() {
        const html = domCache.getHtml();
        
        addUniqueEvent(domCache.getAll(".basket_right .button_light, .basket_right>div:nth-child(1)"), 'click', () => 
            html.classList.remove("basket_right_load")
        , { name: 'click_basket_right' });
        
        addUniqueEvent(domCache.getAll(".basket_right .button_red"), 'click', () => {
            domCache.get(".basket_right .content_mobil_menu")?.dispatchEvent(new Event("click"));
            html.classList.remove("basket_right_load");
        }, { name: 'click_basket_mobil' });
    },

    initBottomMenuEvents() {
        const bottomMenu = domCache.get('#bottom_menu');
        if (!bottomMenu) return;

        bottomMenu.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.target.closest('.menu, .search, .homebutton, .basket');
            
            if (!target) return;
            
            if (target.classList.contains('menu')) {
                domCache.get("#sitecontent .content_mobil_menu")?.click();
            } else if (target.classList.contains('search')) {
                domCache.get(".suche input")?.focus();
            } else if (target.classList.contains('homebutton')) {
                window.location.href = "/";
            } else if (target.classList.contains('basket')) {
                window.location.href = "/basket.html";
            }
        }, { passive: false });
    },

    // ===================================================================
    // AJAX-GELADENE ELEMENTE (werden bei jedem init_nocr neu gebunden)
    // ===================================================================

    async initBasketEvents() {
		if (domCache.get('.content_basket_zahlungsarten[data-payment-provider]'))
		{
            const paymentUtils = await loadModule('paymentUtils');

            if (paymentUtils && paymentUtils.ModuleManager)
            {
                const checkoutMaster = await paymentUtils.ModuleManager.load('checkoutMaster');

                if (checkoutMaster && checkoutMaster.dispatch)
                    checkoutMaster.dispatch();

            }
		}

        const selectedZahlungsart = domCache.get(".content_basket_zahlungsarten:checked");
        
        if (selectedZahlungsart) {
            const labelkasse = (selectedZahlungsart.value == "12") 
                ? "click & reserve" 
                : "jetzt <b>kaufen</b>";
            
            const basketButton = domCache.getAll(".basket_button>button");
            if (basketButton) {
                basketButton.innerHTML = labelkasse;
            }
        }
        
        
        addUniqueEvent(domCache.getAll(".basket_menge>select:not(.init-change-content_basket_intershop)"), 'change', async function() {
            const kasseModule = await loadModule('kasse');
            kasseModule.content_basket_intershop(this);
        }, { name: 'click_basket_menge' });
        
        addUniqueEvent(domCache.getAll(".basket_gutschein"), 'click', async function() {
            const kasseModule = await loadModule('kasse');
            kasseModule.content_basket_gutschein(this);
        }, { name: 'click_basket_gutschein' });
        
        addUniqueEvent(domCache.getAll(".content_basket_zahlungsarten"), 'change', async function() {
            const kasseModule = await loadModule('kasse');
            kasseModule.content_basket_zahlungsart(this);
        }, { name: 'click_basket_payment' });
        
        addUniqueEvent(domCache.getAll('#basket_valid .button_red'), 'click', () => 
            domCache.get("#basket_valid")?.remove()
        , { name: 'click_basket_valid' });
        
        addUniqueEvent(domCache.getAll('#basket_valid .button_grey, .content_basket_delete'), 'click', () => {
            ajax({
                url: "/intershop.ajax?action=delete",
                dataType: "json"
            }).then(response => {
                const basket = domCache.get("#content_basket_basket");
                if (basket) basket.innerHTML = response.content;
                init();
                
                if (response.basket_edit) {
                    Object.entries(response.basket_edit).forEach(([atrnr, value]) => {
                        (window.tagmanagerPushEvent || (e => dataLayer.push(e)))({
                            event: 'remove_from_cart',
                            product_id: [`${value.anr}/0`],
                            google_business_vertical: 'retail',
                            ecommerce: {
                                items: [{
                                    item_id: `${value.anr}/0`,
                                    id: `${value.anr}/0`,
                                    item_variant: `${value.anr}-${atrnr}`,
                                    quantity: value.menge.last - value.menge.now,
                                    google_business_vertical: 'retail'
                                }]
                            },
                            clearEcommerce: true
                        });
                    });
                }
            });
        }, { name: 'click_basket_delete' });

        addUniqueEvent(domCache.getAll('.button_share'), 'click', () => {
            ajax({ url: "/hearty_link.ajax" }).then(async r => {
                if (!r) return;
                
                if (navigator.share) {
                    try {
                        await navigator.share({
                            title: 'slewo.com Wunschliste',
                            url: r
                        });
                    } catch (err) {
                        console.error('Share failed:', err);
                    }
                } else {
                    await Utils.copyToClipboard(r);
                    const el = domCache.get('.button_share');
                    if (el) {
                        const originalHtml = el.innerHTML;
                        el.innerHTML = '» Link wurde erfolgreich kopiert «';
                        setTimeout(() => el.innerHTML = originalHtml, 3000);
                    }
                }
            });
        }, { name: 'click_share' });
    },

    async initCheckoutEvents() {
        addUniqueEvent(domCache.getAll(".content_kasse_shipment_radio"), 'change', async function() {
            const kasseModule = await loadModule('kasse');
            kasseModule.content_kasse_shipment(this);
            // GA4 add_shipping_info Event
            const label = this.closest('td')?.nextElementSibling?.querySelector('label b')?.textContent || this.parentElement?.querySelector('label b')?.textContent || '';
            window.tagmanagerPushEvent({
                event: 'add_shipping_info',
                shipping_tier: label.trim()
            });
        }, { name: 'click_shipment' });
        
        const checkoutForm = domCache.get("#content_kasse_bestellen");
        if (checkoutForm) {
            addUniqueEvent(checkoutForm, 'submit', event => {
                const zahlungsarten = domCache.getAll('input[name="zahlungsart"]');
                const agbCheckbox = domCache.get("#kasse_agb");
                let error = false;
                const blockGruende = [];

                // Stand des vorigen Versuchs raeumen, sonst bleibt ein bereits
                // korrigiertes Feld rot markiert und der alte Hinweis stehen.
                document.querySelectorAll(".kasse_fehler_hinweis").forEach(el => el.remove());
                if (agbCheckbox && agbCheckbox.checked)
                    agbCheckbox.parentElement.classList.remove("error");
                
                if (![...zahlungsarten].some(el => el.checked)) {
                    Utils.showErrorBox(zahlungsarten[0], ".content_basket_box, td", checkoutForm.dataset.msgZahlart);
                    blockGruende.push("zahlungsart");
                    error = true;
                }
                
                if (agbCheckbox && !agbCheckbox.checked) {
                    agbCheckbox.parentElement.classList.add("error");
                    Utils.showErrorBox(agbCheckbox, ".content_basket_box", checkoutForm.dataset.msgAgb);
                    blockGruende.push("agb");
                    error = true;
                }
                
                if (error) {
                    // Blockade in den Checkout-Funnel melden. Ohne das sieht der
                    // Server diese Abbrueche nie — die Client-Validierung faengt sie
                    // ja gerade ab. sendBeacon blockiert den Klick nicht und ueberlebt
                    // einen sofortigen Seitenwechsel.
                    try {
                        const meldung = new URLSearchParams({ reasons: blockGruende.join(",") });
                        if (navigator.sendBeacon)
                            navigator.sendBeacon("/system_data/ajax/checkout_validation_blocked.php", meldung);
                        else
                            fetch("/system_data/ajax/checkout_validation_blocked.php", { method: "POST", body: meldung, keepalive: true });
                    } catch (e) { /* Messung darf den Checkout nie stoeren */ }
                    event.preventDefault();
                    return false;
                }

                // GA4 add_payment_info Event
                const selectedPayment = [...zahlungsarten].find(el => el.checked);
                if (selectedPayment) {
                    const paymentLabel = selectedPayment.closest('td')?.nextElementSibling?.querySelector('label b')?.textContent
                        || selectedPayment.parentElement?.querySelector('label b')?.textContent || '';
                    window.tagmanagerPushEvent({
                        event: 'add_payment_info',
                        payment_type: paymentLabel.trim()
                    });
                }

                const submitButton = domCache.get("#content_kasse_bestellen button.button_waiting");
                if (submitButton) {
                    submitButton.disabled = true;
                    submitButton.classList.add("waiting");
                }
            }, { name: 'submit_checkout' });
        }

        addUniqueEvent(domCache.getAll(".kasse_checkout"), 'submit', async function(event) {
            event.preventDefault();

            if (this.classList.contains('submitting')) return;
            
            this.classList.add('submitting');

            try {
                const kasseModule = await loadModule('kasse');
                
                if (typeof kasseModule.kasse_checkout === 'function') {
                    await kasseModule.kasse_checkout(this);
                } else {
                    console.error("Die Funktion 'kasse_checkout' wurde nicht aus dem Modul exportiert.");
                }
            } catch (error) {
                console.error("Kasse-Modul konnte nicht geladen werden oder die Ausführung schlug fehl:", error);
            } finally {
                this.classList.remove('submitting');
            }
        }, { name: 'submit_kasse_checkout' });
    },

    async initUsichtEvents() {
        addUniqueEvent(domCache.getAll('.content_usicht_page_button'), 'click', event => {
            event.preventDefault();
            event.currentTarget.querySelector('a')?.click();
        }, { name: 'click_usicht_pagebutton' });
        
        addUniqueEvent(domCache.getAll('.content_usicht_page_button a'), 'click', async function(event) {
            event.preventDefault();
            event.stopPropagation();
            if (!event.isVirtualClick) STATE.counters.usichtPage = 0;
            
            const usichtModule = await loadModule('usicht');
            usichtModule.content_usicht_page_show(this);
            return false;
        }, { name: 'click_usicht_pagebutton_a' });
        
        const html = domCache.getHtml();
        addUniqueEvent(domCache.getAll('.content_usicht .hearty, #content_artikel .hearty'), 'click', function(event) {
            event.stopPropagation();
            event.preventDefault();
            
            const type = this.classList.contains('select') ? '0' : '1';
            
            if (type === '0') {
                this.classList.remove('select');
            } else {
                this.classList.add('select', 'click');
                addUniqueEvent(this, 'transitionend', () => this.classList.remove('click'), { once: true });
            }
            
            ajax({
                url: "/hearty_save.ajax",
                data: { type, anr: this.dataset.anr }
            }).then(r => html.classList.toggle("hearty", r > 0));
        }, { name: 'click_usicht_hearty' });
    },

    initMiscEvents() {
        addUniqueEvent(domCache.get('#google-login-btn'), 'click', () => {
            const w = 500, h = 600;
            const l = (screen.width - w) / 2;
            const t = (screen.height - h) / 2;
            window.open('/ext/google/index.html', 'GoogleLogin', `width=${w}, height=${h}, top=${t}, left=${l}`);
        }, { name: 'click_google_login' });

        addUniqueEvent(domCache.getAll(".content_usicht ul>li>a, #content_artikel #breadcrump a, a.ajax"), "click", function(event) {
            event.preventDefault();
            const overflowElement = this.closest(".overflow:not(.show)");
            
            if (overflowElement) {
                overflowElement.classList.add("show");
                return false;
            }
            
            if (this.href) getlink(this.href);
        }, { name: 'click_usicht_breadcrump' });

        addUniqueEvent(domCache.getAll(".content_menu_filter input[type='checkbox']"), 'change', function() {
            this.nextElementSibling.querySelector("a")?.click();
        }, { name: 'click_menu_filter' });
        
        addUniqueEvent(domCache.getAll('a[href^="#"]'), 'click', function(e) {
            e.preventDefault();

            if (this.hash === '') return false;
            
            const targetElement = domCache.get(this.hash);
            if (!targetElement) return false;

            window.scroll({
                top: targetElement.offsetTop,
                left: 0,
                behavior: "smooth"
            });

            window.location.hash = this.hash; 
        }, { name: 'click_link_hash' });

        addUniqueEvent(domCache.getAll(".adresse_type_select input"), 'change', function() {
            const el = domCache.get("#adresse_organization")?.closest("tr");
            el?.classList.toggle("none", this.id == "label_privat" && this.checked);
        }, { name: 'change_adresse_type_select' });
        
        const labelPrivat = domCache.get("#label_privat");
        if (labelPrivat) {
            labelPrivat.dispatchEvent(new Event("change"));
        }

        addUniqueEvent(domCache.getAll(".content_kundenkonto_auftrag_button"), 'click', function() {
            const auftragnr = this.getAttribute("data-auftragnr");
            ajax({
                url: "/kundenkonto_auftrag.ajax",
                data: "auftragnr=" + auftragnr
            }).then(r => {
                const target = domCache.get("#content_kundenkonto_bestellungen_" + auftragnr);
                if (target) target.innerHTML = r;
            });
        }, { name: 'click_kundenkonto_button' });

        addUniqueEvent(domCache.getAll('.content_kasse_payment input.input_check_iban'), 'change', function() {
            content_kasse_cookie(this);
        }, { name: 'click_payment_iban' });
        
        addUniqueEvent(domCache.get("#entsorgung"), 'change', function() {
            domCache.get("#content_artikel_entsorgung")?.classList.toggle("selected", this.checked);
        }, { name: 'change_artikel_trash' });

        //addUniqueEvent(domCache.getAll(".newsletterrabatt"), "click", function() {});
    }
};


/**
 * ===================================================================
 * XVIII. Content-spezifische Manager (Performance-optimiert)
 * ===================================================================
 */

const ContentManagers = {
    async initBannerTop() {
        domCache.getAllArray('.banner_top').forEach(element => {
            const clickEvent = e => {
                e.preventDefault();
                const el = domCache.get(".banner_top");
                if (!el) return;
                
                if (el.classList.contains("show")) {
                    el.style.height = `${el.getAttribute("data-hoehe")}px`;
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                    setTimeout(() => el.classList.remove("show"), 500);
                } else {
                    el.classList.add("show");
                    setTimeout(() => el.style.height = `${el.scrollHeight}px`, 50);
                }
            };
            
            const bannerButton = element.nextElementSibling;
            if (bannerButton?.classList.contains("banner_top_button") && !element.classList.contains("init")) {
                element.setAttribute("data-hoehe", element.clientHeight);
                element.style.height = `${element.clientHeight}px`;
                element.classList.add("init");
                addUniqueEvent(bannerButton, 'click', clickEvent);
            }
        });
    },

    initBannerLoad() {
        domCache.getAllArray(".content_banner_load").forEach(banner => {
            addUniqueEvent(banner, 'click', function() {
                ajax({
                    url: "/banner.ajax",
                    data: "id=" + this.getAttribute("data-banner_id")
                }).then(r => UIComponents.showBannerRabatt(r));
            });
            banner.classList.remove("content_banner_load");
        });

        addUniqueEvent(domCache.getAll(".banner_produktsicherheit"), 'click', function() {
            ajax({
                url: "/produktsicherheit.ajax",
                data: "anr=" + this.dataset.anr
            }).then(r => UIComponents.showBannerRabatt(r));
        });
    },

    initBasketRate() {
        const body = domCache.getBody();
        const html = domCache.getHtml();
        
        addUniqueEvent(domCache.getAll('.basket_rate'), 'click', function() {
            const rateBanner = document.createElement("div");
            rateBanner.className = "banner_ack rate show";
            rateBanner.innerHTML = `
                <div><div><div>
                    <span><span>
                        <strong>Ratenkauf</strong>
                        Der Ratenkauf setzt Bonität voraus und wird nur für Warenkörbe zwischen 45 - 9.999 € angeboten. 
                        <br><br>
                        <h2>Monatliche Wunschrate</h2>
                        <input type='range' class='rate-slider' min='1' max='${this.dataset.rates}' step='1' value='${this.dataset.rates}'>
                        <table>
                            <tr><td>Warenwert</td><td>${this.dataset.warenwert} €</td></tr>
                            <tr><td>Laufzeit</td><td id='finanzierung_laufzeit'></td></tr>
                            <tr><td>Effektiver Jahreszins</td><td id='finanzierung_zinssatz'></td></tr>
                            <tr><td>monatliche Rate</td><td id='finanzierung_monatliche_rate'></td></tr>
                        </table>
                    </span></span>
                    <span></span>
                </div></div></div>
            `;
            body.appendChild(rateBanner);
            setTimeout(() => html.classList.add("banner_load"), 100);
            
            // Event Delegation
            rateBanner.addEventListener('click', function(event) {
                if (event.target === this) {
                    html.classList.remove("banner_load");
                    this.remove();
                }
            }, { passive: true });

            const warenwert = this.dataset.warenwert;
            const cachedResponses = new Map();
            
            const updateFinanzierung = r => {
                domCache.get("#finanzierung_zinssatz").innerHTML = r.effektivZins + " %";
                domCache.get("#finanzierung_laufzeit").innerHTML = r.months + " Monate";
                domCache.get("#finanzierung_monatliche_rate").innerHTML = r.monthlyRate + " €";
            };
            
            const changeSlide = function() {
                const cacheKey = `${warenwert}-${this.value}`;
                
                if (cachedResponses.has(cacheKey)) {
                    updateFinanzierung(cachedResponses.get(cacheKey));
                } else {
                    ajax({
                        url: "/easyCreditRatenrechner.ajax",
                        data: `value=${warenwert}&rate=${this.value}`,
                        dataType: "json"
                    }).then(r => {
                        cachedResponses.set(cacheKey, r);
                        updateFinanzierung(r);
                    });
                }
            };
            
            const slider = rateBanner.querySelector(".rate-slider");
            addUniqueEvent(slider, 'input', changeSlide);
            slider.dispatchEvent(new Event("input", {
                bubbles: true,
                cancelable: true
            }));
        }, { name: 'click_basket_rate' });
    },

    /**
     * Gutscheincode auf der Artikelseite: kopieren und Restlaufzeit.
     *
     * Bewusst hier und nicht im Artikel-Modul: das wird erst bei der ersten
     * Interaktion nachgeladen, und genau die erste Interaktion kann der Griff
     * zum Gutscheincode sein. Beides ist Zugabe - ohne Skript stehen Code und
     * Enddatum als Text da und lassen sich abschreiben.
     */
    initKaufGutschein() {
        const box = domCache.get("#content_artikel_basket_basket .kauf_gutschein");
        if (!box || box.dataset.bereit === "1") return;
        box.dataset.bereit = "1";

        const knopf = box.querySelector(".kauf_code");
        const code = box.dataset.code || "";
        let codeTimer = null;

        if (knopf && code) {
            knopf.addEventListener("click", (event) => {
                // Der Kaufknopf liegt daneben - der Klick darf trotzdem unter
                // keinen Umstaenden weiterlaufen.
                event.preventDefault();
                event.stopPropagation();
                const tat = knopf.querySelector(".kauf_code_tat");
                const melden = () => {
                    knopf.classList.add("kopiert");
                    if (tat) tat.textContent = "Kopiert";
                    clearTimeout(codeTimer);
                    codeTimer = setTimeout(() => {
                        knopf.classList.remove("kopiert");
                        if (tat) tat.textContent = "Kopieren";
                    }, 2000);
                };
                // Der zweite Weg ist kein Alt-Browser-Zugestaendnis: die
                // Zwischenablage verweigert auch in aktuellen Browsern den
                // Dienst (fehlende Berechtigung, kein sicherer Kontext), und
                // dann darf der Knopf nicht einfach nichts tun.
                const ueberFeld = () => {
                    const hilfsfeld = document.createElement("textarea");
                    hilfsfeld.value = code;
                    hilfsfeld.setAttribute("readonly", "");
                    hilfsfeld.style.cssText = "position:fixed;top:-1000px";
                    document.body.appendChild(hilfsfeld);
                    hilfsfeld.select();
                    try { document.execCommand("copy"); } catch (e) {}
                    hilfsfeld.remove();
                    melden();
                };
                if (navigator.clipboard?.writeText) {
                    navigator.clipboard.writeText(code).then(melden).catch(ueberFeld);
                } else {
                    ueberFeld();
                }
            });
        }

        const frist = box.querySelector(".kauf_gutschein_frist");
        const ende = box.dataset.ende ? new Date(box.dataset.ende) : null;
        if (!frist || !ende || isNaN(ende.getTime())) return;

        const zweistellig = (n) => (n < 10 ? "0" + n : "" + n);
        const ticken = () => {
            const rest = ende.getTime() - Date.now();
            if (rest <= 0) { frist.textContent = "Aktion beendet"; return; }
            const tage = Math.floor(rest / 86400000);
            const std = Math.floor((rest % 86400000) / 3600000);
            const min = Math.floor((rest % 3600000) / 60000);
            const sek = Math.floor((rest % 60000) / 1000);
            frist.textContent = tage > 0
                ? `endet in ${tage} T ${zweistellig(std)}:${zweistellig(min)}:${zweistellig(sek)}`
                : `endet in ${zweistellig(std)}:${zweistellig(min)}:${zweistellig(sek)}`;
            setTimeout(ticken, 1000);
        };
        ticken();
    },

    async initArtikelContent() {
        // Nur der Kaufknopf kauft. Frueher hing der Listener am ganzen Kasten -
        // seit dort auch ein Gutscheincode zum Kopieren und ein Herz stehen,
        // waere jeder Griff dorthin ein Kauf gewesen.
        addUniqueEvent(domCache.get("#content_artikel_basket_basket .kauf_cta"), 'click', async function() {
            // Fehlt noch eine Auswahl, kauft der Knopf nicht, sondern oeffnet
            // sie. Ein Kaufknopf, der wortlos nichts tut, ist der schlechteste
            // Zustand von beiden.
            if (this.classList.contains('warten')) {
                const alle = [...document.querySelectorAll('select.content_artikel_attribut_select')];
                // Ausverkaufte Ausführung gewählt: alles ist ausgefüllt, dann
                // führt der Knopf zur ganzen Auswahl zurück
                const felder = this.hasAttribute('data-ausverkauft') && !alle.some(sel => !sel.value)
                    ? alle : alle.filter(sel => !sel.value);
                const mitSheet = felder.filter(sel => sel.dataset.sheet)[0];
                if (mitSheet) {
                    mitSheet.dispatchEvent(new Event('sheet_oeffnen'));
                } else if (felder[0]) {
                    // Kein Sheet an diesem Feld (Skript noch nicht durch, oder
                    // ein Feld ausserhalb der Auswahl): dann wenigstens
                    // hinfuehren statt wortlos nichts zu tun.
                    felder[0].scrollIntoView({ block: 'center' });
                    felder[0].focus();
                }
                return false;
            }
            const artikelModule = await loadModule('artikel');
            ajaxaddbasket(this);
            return false;
        }, { name: 'click_artikel_basket_basket' });

        addUniqueEvent(domCache.get("#content_artikel_basket_basket .kauf_cta"), 'keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
        }, { name: 'kbd_artikel_basket_basket' });

        addUniqueEvent(domCache.get("#content_artikel_basket_basket .kauf_merken"), 'keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
        }, { name: 'kbd_artikel_merken' });

        this.initKaufGutschein();
        
        addUniqueEvent(domCache.getAll("form.shop_kontaktformular"), 'submit', async function(e) {
            e.preventDefault();
            const artikelModule = await loadModule('artikel');
            shop_kontaktformular(this);
        }, { name: 'submit_shop_kontaktformular' });

        if (domCache.get("#menge_box") || domCache.get("#content_artikel")) {
            const artikelModule = await loadModule('artikel');
            content_artikel_init();
            content_artikel_image_init();
        }

        if (typeof content_artikel_attribut === 'function') {
            addUniqueEvent(domCache.getAll(".content_artikel_attribut_select"), "change", content_artikel_attribut);
        }
        
        const contentArtikelAttribut = domCache.get("#content_artikel_attribut");
        if (contentArtikelAttribut?.dataset.attribut_load) {
            const attributLoad = contentArtikelAttribut.dataset.attribut_load;
            let selectElement = false;
            
            Object.entries(attributLoad).forEach(([index, value]) => {
                const select = domCache.get(`#content_artikel_attribut select[data-name='${index}']`);
                if (select) {
                    const selectedOption = Array.from(select.options).find(option => option.value === value);
                    if (selectedOption) {
                        selectedOption.selected = true;
                        selectElement = select;
                    }
                }
            });
            
            selectElement?.dispatchEvent(new Event("change"));
        }
    },

    async initUsichtFilter() {
        domCache.getAllArray(".content_usicht_filter_preis").forEach(async el => {
            if (!el.querySelector("input.min")) {
                const usichtModule = await loadModule('usicht');
                usichtModule.content_usicht_preis_slider(el);
            }
        });

        domCache.getAllArray('.content_usicht_filter>div>div>div>div>div:first-child').forEach(element => {
            addUniqueEvent(element, 'click', () => {
                const parent = element.parentElement.parentElement.parentElement;
                const openFilter = !parent.classList.contains('active');
                const activeElements = element.closest('.content_usicht_filter').querySelectorAll('.active');
                const timing = activeElements.length ? 800 : 0;

                // Batch DOM Updates
                Utils.batchDOMUpdates(() => {
                    activeElements.forEach(el => {
                        el.querySelectorAll('div>div').forEach(div => {
                            div.style.height = '';
                            div.style.width = '';
                        });
                        el.classList.remove('active');
                    });
                    
                    element.closest('.content_usicht_filter').querySelectorAll('.right').forEach(right => 
                        right.classList.remove('right')
                    );

                    const contentUsicht = domCache.get('#content_usicht');
                    const l2 = contentUsicht.offsetWidth + contentUsicht.offsetLeft;
                    
                    domCache.getAllArray('.content_usicht_filter>div>div').forEach(filter => {
                        const l = filter.offsetWidth + filter.offsetLeft;
                        filter.querySelectorAll('div>div').forEach(div => {
                            if (filter.offsetWidth * 1.2 > l2) {
                                div.classList.add('middle');
                            } else if (l * 1.2 > l2) {
                                div.classList.add('right');
                            }
                        });
                    });
                });

                if (openFilter) {
                    setTimeout(() => {
                        const actualSizeSum = 
                            actualSize(element.nextElementSibling.querySelector(".content_usicht_filter_preis")).height +
                            actualSize(element.nextElementSibling.querySelector("ul")).height +
                            actualSize(element.nextElementSibling.querySelector("ul+div")).height;
                        
                        const h = Math.min(element.offsetHeight + actualSizeSum + 30, 250);
                        
                        const maxWidth = Array.from(element.parentElement.querySelectorAll('label'))
                            .reduce((acc, label) => Math.max(acc, label.offsetWidth), 0) +
                            element.offsetWidth - element.nextElementSibling.offsetWidth;
                        
                        if (maxWidth > element.parentElement.offsetWidth * 1.2) {
                            element.parentElement.style.width = `${maxWidth}px`;
                        }
                        
                        element.parentElement.style.height = `${h}px`;
                        parent.classList.add('active');
                    }, timing);
                }
            }, { name: 'click_filter_change' });
        });

        addUniqueEvent(domCache.getAll('.content_usicht_filter input[type="checkbox"]'), 'change', function() {
            const closestList = this.closest('.liste_checkbox');

            if (closestList?.classList.contains('unique')) {
                closestList.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
                this.checked = true;
            }

            const ul = this.closest('ul');
            if (!ul) return;

            const btn = ul.parentNode.querySelector('.button_ani');
            if (!btn) return;

            const checkboxes = ul.querySelectorAll('input[type="checkbox"]');
            const reloadFilter = Array.from(checkboxes).some(cb => cb.checked !== (cb.dataset.load === 'checked'));

            btn.classList.toggle('select', reloadFilter);
            btn.textContent = reloadFilter ? 'ÜBERNEHMEN' : 'SCHLIESSEN';
        }, { name: 'change_filter_checkbox' });

        addUniqueEvent(domCache.getAll('.content_usicht_filter a'), 'click', e => e.preventDefault(), {
            preventDefault: true,
            overwrite: true
        }, { name: 'click_filter_a' });
        
        addUniqueEvent(domCache.getAll(".content_usicht_filter .button_ani"), 'click', async function() {
            const usichtModule = await loadModule('usicht');
            usichtModule.content_usicht_filter_load(this);
        }, { name: 'click_usicht_filter_button_ani' });

        addUniqueEvent(domCache.getAll(".content_usicht_filter .checkbox_slide"), "change", function() {
            setTimeout(async () => {
                const usichtModule = await loadModule('usicht');
                usichtModule.content_usicht_filter_load(this);
            }, 300);
        }, { name: 'change_filter_slider' });
        
        addUniqueEvent(domCache.getAll(".content_usicht_filter a"), 'click', function() {
            this.previousElementSibling?.click();
            return false;
        }, { name: 'click_usicht_filter_a' });
        
        addUniqueEvent(domCache.getAll(".content_usicht_filter"), 'click', function() {
            const firstChild = this.querySelector(".content_usicht_filter>div:first-child");
            if (firstChild && getComputedStyle(firstChild).display === "none") {
                this.classList.add("select");
            }
        }, { name: 'click_usicht_filter' });
    }
};

/**
 * ===================================================================
 * XIX. Usicht Mover (Performance-optimiert)
 * ===================================================================
 */

const UsichtMover = {
    isHovering: null,
    pendingRequests: new Map(),
    videoTimer: new WeakMap(),
    videoAnlauf: new WeakMap(),

    // Sicherheitsnetz: Bleibt das ended-Ereignis aus (Ladefehler, leerer Puffer),
    // schaltet der Slider nach Videolänge plus diesem Zuschlag trotzdem weiter.
    VIDEO_NOTBREMSE_MS: 3000,
    // Zweites Sicherheitsnetz, das schon vor den Metadaten greift: Kommt das
    // Video gar nicht erst zustande (404, oder der Resizer rendert eine kalte
    // Stufe und läuft in einen Fehler), feuert weder loadedmetadata noch ended -
    // und der Slider stünde still, weil das Flag den Bild-Takt anhält.
    VIDEO_START_NOTBREMSE_MS: 6000,
    // Anlauf: das Video nimmt seine Geschwindigkeit weich auf, statt aus dem
    // Standbild heraus zu springen.
    VIDEO_ANLAUF_RATE: 0.4,
    VIDEO_ANLAUF_SCHRITT: 0.15,
    VIDEO_ANLAUF_SCHRITT_MS: 90,
    // Eine Stufe darf bis zu 8 % schmaler sein als die benoetigte
    // Pixelbreite - dieselbe Toleranz wie in der Artikel-Galerie
    // (artikel.image.js, STUFE_TOLERANZ), dort mit Begruendung.
    VIDEO_STUFE_TOLERANZ: 0.92,
    // Stocker-Waechter wie in der Galerie: zweimal binnen 10 s laenger als
    // 150 ms angehalten -> eine Stufe tiefer, auf der kleinsten Stufe
    // zurueck zum Standbild. Ein ruckelndes Video neben dem Preis wirkt
    // schlechter als gar keines.
    VIDEO_STOCKER_MIN_MS: 150,
    VIDEO_STOCKER_FENSTER_MS: 10000,
    VIDEO_STOCKER_GRENZE: 2,
    VIDEO_DECKEL_DAUER_MS: 15 * 60 * 1000,
    // Ergebnis der letzten pickVideoSrc-Wahl: gewaehlte Breite und die
    // naechstkleinere. pickVideoSrc gibt nur die URL zurueck, der Waechter
    // braucht aber die Stufe, von der aus er absteigt.
    letzteStufe: null,

    init(el, b, response) {
        // Der MutationObserver im mouseenter-Handler kann mehrere Klassen-
        // änderungen in EINEM Stapel liefern; sein forEach läuft nach dem
        // disconnect weiter. Ohne diesen Riegel hängt die Bilderkette doppelt
        // im Streifen (gemessen: 17 Bilder bei 9 Slider-Punkten).
        if (el.classList.contains("moverload")) return;

        if (response.bilder) el.insertAdjacentHTML("beforeend", response.bilder);
        el.classList.add("moverload");

        // Das erste Bild steht bereits in der Kachel, sein Video kommt deshalb
        // getrennt. Hier wandert es in dieselben data-Attribute, die die
        // nachgeladenen Bilder mitbringen - ab da sind alle Slides gleich.
        if (response.video) {
            const erstes = el.querySelector('img');
            if (erstes) {
                erstes.dataset.video = response.video.src || '';
                erstes.dataset.videoSrcset = response.video.srcset || '';
            }
        }
        
        if (response.color) {
            const ul = document.createElement('ul');
            ul.className = "color";
            ul.insertAdjacentHTML("beforeend", response.color);
            el.parentNode.appendChild(ul);
        }
        
        if (!b.querySelector('a>span:first-child>ul.mover')) {
            const ulElement = document.createElement('ul');
            ulElement.className = 'mover';
            const images = b.querySelectorAll('a>span:first-child>span:first-child>img');
            
            if (images.length <= 1) {
                // Ein einzelnes Bild hat keinen Durchlauf - ein etwaiges Video
                // startet initControls, damit es auch beim zweiten Hover läuft.
                this.initControls(b);
                return;
            }
            
            const fragment = document.createDocumentFragment();
            images.forEach(() => {
                const liElement = document.createElement('li');
                liElement.appendChild(document.createElement('span'));
                fragment.appendChild(liElement);
            });
            ulElement.appendChild(fragment);
            b.querySelector('a>span:first-child').appendChild(ulElement);
        }
        init();
        this.initControls(b);
    },

    initControls(e) {
        if (!e.querySelector('a>span:first-child>ul.mover')) {
            // Kachel mit einem einzigen Bild: kein Durchlauf, aber ihr Video soll
            // bei jedem Hover laufen - in Schleife, weil es nichts gibt, wohin
            // weitergeschaltet werden könnte.
            const bilder = e.querySelectorAll('a>span:first-child>span:first-child>img');
            if (bilder.length === 1) this.videoZeigen(e, bilder[0], 1, true);
            return;
        }
        
        const transitionendEvent = () => {
            // Auf einem Video-Slide bestimmt das Video das Weiterschalten, nicht
            // der Fortschrittsbalken - sonst liefen beide gegeneinander.
            if (e.dataset.moverVideo === '1') return;
            e.setAttribute('data-mover_current', parseInt(e.getAttribute('data-mover_current') || 1) + 1);
            this.move(e);
        };
        
        e.querySelectorAll("a>span:first-child>ul.mover li span").forEach(span => 
            addUniqueEvent(span, 'transitionend', transitionendEvent, { passive: true })
        );
        
        e.querySelectorAll("a>span:first-child>ul.mover li").forEach((element, index) => {
            addUniqueEvent(element, 'click', event => {
                event.stopPropagation();
                event.preventDefault();
                e.setAttribute('data-mover_current', index + 1);
                this.move(e);
            }, { name: 'click_init_mover' });
        });
        
        const ael = e.querySelector("a");
        ael.dataset.originaltitle = ael.title;
        ael.title = '';
        setTimeout(() => this.move(e), 100);
    },

    move(e) {
        if (this.isHovering !== e) return;
        
        let current = parseInt(e.getAttribute('data-mover_current')) || 1;
        const images = e.querySelectorAll('a>span:first-child>span:first-child>img');
        
        if (current > images.length) {
            current = 1;
            e.setAttribute('data-mover_current', '1');
        }
        
        // Batch Class Updates
        Utils.batchDOMUpdates(() => {
            e.querySelectorAll("a>span:first-child>ul.mover li.select").forEach(el => el.classList.remove("select"));
            e.querySelector(`a>span:first-child>ul.mover li:nth-child(${current})`)?.classList.add("select");
            
            const element = e.querySelector("a>span:first-child>span:first-child");
            element.style.transform = `translate3D(${(current - 1) * -100}%, 0, 0)`;
        });
        
        // Steht der Slider auf einem Bild mit Video, läuft dieses ab und bestimmt,
        // wie lange der Slide stehen bleibt.
        this.videoZeigen(e, images[current - 1], current, false);
    },

    /**
     * Spielt das Video des gerade sichtbaren Slides ab - oder räumt ein noch
     * laufendes ab, wenn dieser Slide keines trägt.
     */
    videoZeigen(e, img, current, dauerschleife) {
        this.videoAbraeumen(e);

        // Die Antwort des Servers kann eintreffen, nachdem die Maus die Kachel
        // schon wieder verlassen hat - dann wird kein Video mehr geladen.
        if (this.isHovering !== e) return;
        if (!img || !img.dataset.video) return;
        if (this.isVideoUnerwuenscht()) return;

        const video = this.videoElement(e);
        // Die Slides liegen nebeneinander im Streifen, der beim Wechsel
        // verschoben wird. Das Video muss über dem richtigen sitzen und mitwandern.
        video.style.left = ((current - 1) * 100) + '%';
        video.loop = !!dauerschleife;

        // Der normale Durchlauf bekommt die Vorwärts-Fassung. Das halbiert
        // nicht nur die Übertragung, sondern auch die SPIELZEIT: bisher lief
        // hier die gespiegelte Aufnahme ganz durch (20 s hin und zurück),
        // erst danach schaltete onended weiter. Künftig sind es 10 s, und
        // der Slide wechselt entsprechend früher. Beides ist gewollt - eine
        // einzelne Kachel 20 Sekunden lang stehen zu lassen, war zu lang.
        //
        // Die Dauerschleife behält den Boomerang. Ohne den gespiegelten
        // Teil springt das Bild am Loop-Ende hart auf den Anfang zurück.
        this.videoQuelleSetzen(video, () => this.pickVideoSrc(img, !dauerschleife));

        // Solange dieses Flag steht, schaltet nur das Video weiter.
        e.dataset.moverVideo = dauerschleife ? '' : '1';

        // Den Balken sofort stilllegen. Sonst läuft zwischen Slide-Wechsel und
        // dem Eintreffen der Metadaten die normale 3-Sekunden-Füllung an - beim
        // Rendern einer kalten Größenstufe stünde er voll, bevor das Video
        // überhaupt spielt, und spränge danach zurück.
        if (!dauerschleife) {
            const punkt = e.querySelector(`a>span:first-child>ul.mover li:nth-child(${current})`);
            if (punkt) {
                punkt.style.setProperty('--mover-fortschritt-transition', 'none');
                punkt.style.setProperty('--mover-fortschritt', '0%');
            }
        }

        video.onloadedmetadata = () => this.balkenAnVideoKoppeln(e, video, current);
        video.onended = dauerschleife ? null : () => this.videoWeiter(e, current);
        video.onerror = () => {
            // In Dauerschleife gibt es kein Weiterschalten - dann bleibt nur,
            // das leere Video wieder auszublenden, damit das Bild frei liegt.
            if (dauerschleife) { video.style.opacity = '0'; return; }
            this.videoWeiter(e, current);
        };
        if (!dauerschleife) this.notbremse(e, video, current, this.VIDEO_START_NOTBREMSE_MS);

        this.videoStarten(video);
    },

    videoElement(e) {
        const streifen = e.querySelector('a>span:first-child>span:first-child');
        let video = streifen.querySelector('video');
        if (video) return video;

        video = document.createElement('video');
        video.muted = true;
        video.playsInline = true;
        video.preload = 'none';
        // Kein z-index: so bleibt das Herz-Icon, das später im DOM steht, oben.
        video.style.cssText = 'position:absolute;top:0;width:100%;height:100%;'
            + 'object-fit:cover;opacity:0;transition:opacity .35s ease;pointer-events:none;';
        streifen.appendChild(video);
        this.videoStockerWaechter(video);
        return video;
    },

    /**
     * Setzt die Quelle und merkt sich, wie sie neu zu waehlen ist - der
     * Stocker-Waechter ruft das nach dem Setzen des Deckels erneut auf und
     * bekommt so dieselbe Wahl, nur eine Stufe kleiner. `aufgeben` laeuft,
     * wenn es keine kleinere Stufe mehr gibt.
     */
    videoQuelleSetzen(video, waehlen, aufgeben) {
        video._stufeNeu = () => {
            const url = waehlen();
            const s = this.letzteStufe;
            video.dataset.stufe = s ? String(s.breite) : '';
            video.dataset.stufeTiefer = s && s.tiefer ? String(s.tiefer) : '';
            return url;
        };
        video._stockerAufgeben = aufgeben || null;
        video._stocker = [];
        video._wechselNr = (video._wechselNr || 0) + 1;
        video._wechselt = false;
        video.src = video._stufeNeu();
    },

    /**
     * Zaehlt echte Stocker - dieselben Regeln wie der Waechter der Galerie
     * (artikel.image.js, _stockerWaechter), dort mit Begruendung: erst nach
     * dem ersten `playing` der Quelle (der Anlauf ist kein Stocker), nicht
     * beim Suchen (Schleifenende), nicht waehrend eines Wechsels, eine Pause
     * verwirft die Messung, gezaehlt ab VIDEO_STOCKER_MIN_MS.
     *
     * Die Messung lebt am Element und nicht an der Kachel: Hover-Slider und
     * Autoplay teilen sich dasselbe <video>, und jede neue Quelle - auch die
     * des naechsten Slides - setzt sie ueber loadstart/emptied zurueck.
     */
    videoStockerWaechter(video) {
        let seit = null;
        let angelaufen = false;
        video._stocker = [];

        const messungVerwerfen = () => { seit = null; };
        const neueQuelle = () => { seit = null; angelaufen = false; };
        video.addEventListener('pause', messungVerwerfen, { passive: true });
        video.addEventListener('emptied', neueQuelle, { passive: true });
        video.addEventListener('loadstart', neueQuelle, { passive: true });

        video.addEventListener('waiting', () => {
            if (!angelaufen || video._wechselt || video.seeking || video.paused) return;
            seit = performance.now();
        }, { passive: true });
        video.addEventListener('playing', () => {
            if (!angelaufen) { angelaufen = true; return; }
            if (seit === null) return;
            const jetzt = performance.now();
            const dauer = jetzt - seit;
            seit = null;
            if (video._wechselt || dauer < this.VIDEO_STOCKER_MIN_MS) return;
            video._stocker = (video._stocker || []).filter(t => jetzt - t < this.VIDEO_STOCKER_FENSTER_MS);
            video._stocker.push(jetzt);
            if (video._stocker.length >= this.VIDEO_STOCKER_GRENZE) this.videoStufeRunter(video);
        }, { passive: true });
    },

    videoStufeRunter(video) {
        if (video._wechselt) return;
        video._stocker = [];
        const tiefer = parseInt(video.dataset.stufeTiefer, 10);
        const url = tiefer && video._stufeNeu
            ? (this.deckelSetzen(tiefer), video._stufeNeu())
            : '';
        if (!url || new URL(url, window.location.href).href === video.currentSrc) {
            if (video._stockerAufgeben) video._stockerAufgeben();
            return;
        }

        // An derselben Stelle weiter - der Wechsel soll wie kurzes
        // Nachladen aussehen, nicht wie ein Neustart. Die Nummer haelt die
        // einmaligen Listener still, sobald der Wechsel ueberholt ist
        // (videoAbraeumen, naechste Quelle): Sie haengen am geteilten
        // Element und saehen sonst das Video des NAECHSTEN Slides.
        const stelle = video.currentTime;
        const nr = video._wechselNr = (video._wechselNr || 0) + 1;
        video._wechselt = true;
        video.addEventListener('loadedmetadata', () => {
            if (nr !== video._wechselNr) return;
            try {
                video.currentTime = Math.min(stelle, Math.max(0, video.duration - 0.1));
            } catch (e) { /* dann eben von vorn */ }
        }, { once: true });
        video.addEventListener('playing', () => {
            if (nr === video._wechselNr) video._wechselt = false;
        }, { once: true });
        // Scheitert die kleinere Stufe, greift das onerror des Spielers
        // (Weiterschalten bzw. Standbild) - und das raeumt ueber
        // videoAbraeumen auch _wechselt ab.
        video.src = url;
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
    },

    /**
     * Groesste Stufenbreite nach einem erkannten Engpass (0 = keine Grenze).
     * Derselbe Schluessel wie in artikel.image.js - Kachel und Galerie
     * lernen voneinander. Befristet, weil Last voruebergehend ist.
     */
    deckelLesen() {
        try {
            const d = JSON.parse(window.sessionStorage.getItem('slewo_video_deckel') || 'null');
            if (d && d.breite > 0 && d.bis > Date.now()) return d.breite;
        } catch (e) { /* sessionStorage gesperrt oder Inhalt unlesbar */ }
        return 0;
    },

    deckelSetzen(breite) {
        const alt = this.deckelLesen();
        try {
            window.sessionStorage.setItem('slewo_video_deckel', JSON.stringify({
                breite: alt ? Math.min(alt, breite) : breite,
                bis: Date.now() + this.VIDEO_DECKEL_DAUER_MS
            }));
        } catch (e) { /* ohne Speicher gilt die Grenze nur fuer dieses Video */ }
    },

    videoStarten(video, sanft) {
        video.playbackRate = this.VIDEO_ANLAUF_RATE;

        // Ohne `sanft` blendet das Video sofort ein - beim Hover-Slider ist
        // es nach dem ersten Durchlauf meist schon gepuffert, und jede
        // Verzoegerung waere dort nur traege.
        //
        // Mit `sanft` wartet das Einblenden auf das erste Bild. Sonst
        // blendet man Schwarz ein und das Bild springt hinterher - genau
        // dann, wenn das Video frisch geladen wird.
        if (sanft) {
            video.style.opacity = '0';
            video.onloadeddata = () => { video.style.opacity = '1'; };
        } else {
            video.style.opacity = '1';
        }

        const abspielen = video.play();
        if (abspielen && abspielen.catch) abspielen.catch(() => {});

        clearInterval(this.videoAnlauf.get(video));
        this.videoAnlauf.set(video, setInterval(() => {
            const rate = Math.min(1, video.playbackRate + this.VIDEO_ANLAUF_SCHRITT);
            video.playbackRate = rate;
            if (rate >= 1) clearInterval(this.videoAnlauf.get(video));
        }, this.VIDEO_ANLAUF_SCHRITT_MS));
    },

    /**
     * Der Fortschrittsbalken eines Slides läuft per CSS 3 s. Auf einem
     * Video-Slide zeigt er stattdessen, wie weit das Video ist.
     *
     * Er hängt dafür am tatsächlichen Abspielstand, nicht an einer einmal
     * gesetzten Laufzeit: Eine feste Transition über die Videolänge läuft
     * stur weiter, während das Video verzögert startet, wegen der Anlauframpe
     * anfangs langsamer spielt und bei jedem Nachpuffern stehen bleibt - der
     * Balken wäre dann längst voll, obwohl das Bild noch steht.
     */
    balkenAnVideoKoppeln(e, video, current) {
        if (!isFinite(video.duration) || !video.duration) return;

        // Der sichtbare Balken ist das ::before des li - ein Pseudoelement,
        // erreichbar nur über eine Custom Property. Das span daneben ist
        // unsichtbar und bleibt der Taktgeber für die Bild-Slides.
        const punkt = e.querySelector(`a>span:first-child>ul.mover li:nth-child(${current})`);
        // Auf 0 steht der Balken schon seit videoZeigen; ab jetzt bewegt er sich,
        // deshalb die kurze Transition zum Glätten - timeupdate meldet sich nur
        // rund viermal je Sekunde, ohne sie ruckelte der Balken sichtbar.
        if (punkt) punkt.style.setProperty('--mover-fortschritt-transition', 'width .25s linear');

        video.ontimeupdate = () => {
            if (!isFinite(video.duration) || !video.duration) return;
            const anteil = Math.min(1, video.currentTime / video.duration);
            if (punkt) punkt.style.setProperty('--mover-fortschritt', (anteil * 100) + '%');

            // Die Notbremse wandert mit dem Fortschritt mit. Eine fest auf die
            // Videolänge gestellte Bremse würde bei jeder Pufferpause mitten im
            // laufenden Video weiterschalten. In Dauerschleife gibt es nichts
            // weiterzuschalten - dort braucht es sie nicht.
            if (e.dataset.moverVideo !== '1') return;
            const rest = Math.max(0, video.duration - video.currentTime);
            this.notbremse(e, video, current, rest * 1000 + this.VIDEO_NOTBREMSE_MS);
        };

        if (e.dataset.moverVideo === '1') {
            this.notbremse(e, video, current, video.duration * 1000 + this.VIDEO_NOTBREMSE_MS);
        }
    },

    notbremse(e, video, current, ms) {
        clearTimeout(this.videoTimer.get(video));
        this.videoTimer.set(video, setTimeout(() => this.videoWeiter(e, current), ms));
    },

    videoWeiter(e, current) {
        if (this.isHovering !== e) return;
        if (e.dataset.moverVideo !== '1') return;   // schon weitergeschaltet

        e.dataset.moverVideo = '';
        e.setAttribute('data-mover_current', current + 1);
        this.move(e);
    },

    /**
     * Hält ein laufendes Video an und gibt seine Quelle frei, damit nicht jede
     * besuchte Kachel Decoder und Puffer offen hält.
     */
    videoAbraeumen(e) {
        e.dataset.moverVideo = '';

        // Ohne Video gab es auch nie Inline-Styles am Balken - dann ist hier
        // nichts aufzuräumen, und der Bilder-Slider zahlt nichts für die
        // Video-Fähigkeit.
        const video = e.querySelector('a>span:first-child>span:first-child>video');
        if (!video) return;

        // Den Balken wieder dem CSS überlassen, sonst trägt er den Stand des
        // letzten Videos in den nächsten Durchlauf.
        e.querySelectorAll("a>span:first-child>ul.mover li").forEach(punkt => {
            punkt.style.removeProperty('--mover-fortschritt');
            punkt.style.removeProperty('--mover-fortschritt-transition');
        });

        clearTimeout(this.videoTimer.get(video));
        clearInterval(this.videoAnlauf.get(video));
        video.onended = null;
        video.onloadedmetadata = null;
        video.onloadeddata = null;
        video.onerror = null;
        video.ontimeupdate = null;
        video._stufeNeu = null;
        video._stockerAufgeben = null;
        video._stocker = [];
        video._wechselNr = (video._wechselNr || 0) + 1;
        video._wechselt = false;
        video.style.opacity = '0';
        video.pause();

        if (video.getAttribute('src')) {
            video.removeAttribute('src');
            video.load();
        }
    },

    /**
     * Die Vorwärts-Fassung derselben Größenstufe.
     *
     * Der Resizer rendert unter den IDs 5-8 dieselben Breiten wie unter
     * 1-4, aber ohne den angehängten Rückwärtslauf. Bei gleicher Qualität
     * ist das rund die halbe Datei (gemessen an 480 px: 1.833.902 gegen
     * 922.446 Byte), und die Vorwärts-Stufen skalieren zusätzlich nicht
     * hoch - bei den 800-px-Quellen spart Stufe 5 gegenüber Stufe 1 den
     * Faktor 3,45.
     *
     * Sie taugt nur für genau einen Durchlauf. In Dauerschleife fehlt der
     * gespiegelte Teil, und das Bild springt am Loop-Ende hart zurück.
     *
     * Das Plus 4 ist an `$bildsize` in image_artikel_video_resize.php
     * gekoppelt und an shop_build_link.php, das die srcset-URLs baut.
     * Greift der Ersatz nicht, bleibt die Boomerang-Fassung stehen: die ist
     * größer, aber in jedem Fall richtig.
     */
    vorwaertsVariante(url) {
        return url.replace(
            /\/image\/artikelvideo([1-4])\//,
            (treffer, stufe) => `/image/artikelvideo${Number(stufe) + 4}/`
        );
    },

    /**
     * <video> kennt kein natives srcset - die passende der vier Größen
     * (300/480/800/1200) wählen wir hier selbst, anhand des Bildes, über dem
     * das Video liegen wird.
     *
     * `vorwaerts` verlangt zusätzlich die Fassung ohne Rückwärtslauf. Das
     * darf nur setzen, wer ohne `loop` genau einmal abspielt.
     */
    pickVideoSrc(img, vorwaerts) {
        const fassung = url => (vorwaerts && url ? this.vorwaertsVariante(url) : url);

        this.letzteStufe = null;
        const fallback = fassung(img.dataset.video || '');
        const srcset = img.dataset.videoSrcset || '';
        if (!srcset) return fallback;

        const alle = srcset.split(',')
            .map(teil => teil.trim().match(/^(\S+)\s+(\d+)w$/))
            .filter(Boolean)
            .map(treffer => ({ url: treffer[1], breite: parseInt(treffer[2], 10) }))
            .sort((a, b) => a.breite - b.breite);

        if (!alle.length) return fallback;

        // Nach einem erkannten Engpass nur Stufen bis zum Deckel. Bleibt
        // keine uebrig, die kleinste - kleiner geht es nicht.
        const deckel = this.deckelLesen();
        const erlaubt = deckel ? alle.filter(stufe => stufe.breite <= deckel) : alle;
        const stufen = erlaubt.length ? erlaubt : [alle[0]];

        // Merkt die Wahl samt naechstkleinerer Stufe fuer den Stocker-Waechter.
        const nimm = stufe => {
            const tiefer = alle.filter(s => s.breite < stufe.breite).pop();
            this.letzteStufe = { breite: stufe.breite, tiefer: tiefer ? tiefer.breite : 0 };
            return fassung(stufe.url);
        };

        // Steht das Layout noch nicht, ist die Breite 0. Dann die kleinste Stufe
        // nehmen - hochskalieren wäre genau die falsche Richtung, wenn man gar
        // nicht weiß, wie groß die Kachel ist.
        const gemessen = img.getBoundingClientRect().width;
        if (!gemessen) return nimm(stufen[0]);

        // Darstellungsbreite mal Pixeldichte, bei Faktor 2 gedeckelt: darüber ist
        // der Schärfegewinn auf einer Kachel dieser Größe nicht mehr sichtbar,
        // die Datenmenge aber schon. Dazu die Toleranz: eine Stufe knapp unter
        // der Zielbreite sieht niemand, die naechstgroessere kostet das Doppelte.
        const breite = gemessen * Math.min(window.devicePixelRatio || 1, 2) * this.VIDEO_STUFE_TOLERANZ;

        let index = stufen.findIndex(stufe => stufe.breite >= breite);
        if (index < 0) index = stufen.length - 1;

        // Auf schmaler Leitung eine Stufe kleiner. Die Bitraten liegen je
        // nach Motiv zwischen 0,9 und 2,8 Mbit/s - wer darunter liegt, sieht
        // mehr Puffern als Video. Geprüft wird downlink und nicht
        // effectiveType: dessen Stufen (3g/4g) sind zu grob, und die groben
        // Fälle fängt isVideoUnerwuenscht ohnehin schon vorher ab.
        //
        // Nur auf Geräten ohne Hover. downlink ist eine Schätzung aus dem
        // zuletzt beobachteten Durchsatz und liegt kurz nach dem
        // Seitenaufbau - zwei Dutzend Kachelbilder gleichzeitig - auch auf
        // einer schnellen Leitung unter 3. Am Schreibtisch würde damit der
        // erste Hover grundlos eine Stufe verlieren; dort ist Bandbreite
        // ohnehin selten das Problem.
        const ohneHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
        const leitung = navigator.connection && navigator.connection.downlink;
        if (ohneHover && leitung && leitung < 3 && index > 0) index--;

        return nimm(stufen[index]);
    },

    /**
     * Kein Video bei Datensparmodus, langsamer Leitung oder schwacher Hardware.
     * Der Bilder-Durchlauf läuft dann normal weiter, die betroffenen Slides
     * bleiben schlicht Standbilder.
     *
     * prefers-reduced-motion zählt seit 2026-09-21 NICHT mehr dazu — gleiche
     * Entscheidung wie in artikel.image.js (_isGlobalLowPower), Begründung
     * dort. Beide Stellen zusammen ändern, sonst zeigt die eine Seite ein
     * Video und die andere nicht.
     */
    isVideoUnerwuenscht() {

        const verbindung = navigator.connection;
        if (verbindung) {
            if (verbindung.saveData) return true;
            if (/(^|-)2g$|^3g$/.test(verbindung.effectiveType || '')) return true;
        }

        return (navigator.hardwareConcurrency || 8) < 4;
    },

    setupEvents() {
        // Selektor ohne html.mouse. Die Klasse aendert sich zur Laufzeit
        // (siehe initBasicEvents), die Bindung findet aber nur einmal
        // statt: Stand sie in diesem Augenblick auf 'touch', gab es den
        // Hover-Slider danach nie wieder - auch nicht, wenn eine Maus
        // angeschlossen wurde. Gefragt wird deshalb erst im Handler.
        const content_usicht_items = domCache.getAll("#content_usicht>ul:not(.content_usicht_banner_box)>li");

        addUniqueEvent(content_usicht_items, 'mouseenter', function() {
            // Am Finger feuert mouseenter ueber die Kompatibilitaetskette
            // mit. Dort gehoert der Hover-Slider nicht hin, dort spielt
            // UsichtVideoAuto.
            if (!domCache.getHtml().classList.contains('mouse')) return;

            // Auf einem Tablet mit Maus oder Trackpad ist BEIDES wahr:
            // (hover: none) matcht, also laeuft UsichtVideoAuto, und der
            // Zeiger loest trotzdem mouseenter aus. Laeuft hier gerade ein
            // Autoplay-Video, gehoert es ordentlich beendet, bevor der
            // Mover dasselbe <video> uebernimmt - sonst nullt dessen
            // videoAbraeumen Quelle und Taktgeber, die Kachel bliebe in
            // `aktive` stehen und waere bis zum Ausscrollen blockiert.
            if (UsichtVideoAuto.aktive.has(this)) UsichtVideoAuto.stoppen(this);

            UsichtMover.isHovering = this;
            const el = this.querySelector('a>span:first-child>span:first-child');
            
            if (el && !el.classList.contains("moverload")) {
                const anr = this.querySelector('.hearty')?.dataset.anr;
                if (!anr) return;
                
                // Prüfe ob Request bereits pending ist
                if (UsichtMover.pendingRequests.has(anr)) {
                    UsichtMover.pendingRequests.get(anr).then(response => {
                        if (el.classList.contains("load")) {
                            UsichtMover.init(el, this, response);
                        }
                    });
                    return;
                }
                
                // Neuer Request mit Caching
                const requestPromise = ajax({
                    url: "/artikel_usicht_bilder.ajax",
                    data: { anr },
                    dataType: "json"
                });
                
                UsichtMover.pendingRequests.set(anr, requestPromise);
                
                requestPromise.then(response => {
                    if (el.classList.contains("load")) {
                        UsichtMover.init(el, this, response);
                    } else {
                        const observer = new MutationObserver(mutations => {
                            mutations.forEach(mutation => {
                                if (mutation.type === "attributes" && 
                                    mutation.attributeName === "class" && 
                                    el.classList.contains("load")) {
                                    UsichtMover.init(el, this, response);
                                    observer.disconnect();
                                }
                            });
                        });
                        observer.observe(el, { attributes: true });
                    }
                }).finally(() => {
                    // Request aus Cache entfernen nach 5 Sekunden
                    setTimeout(() => UsichtMover.pendingRequests.delete(anr), 5000);
                });
            } else {
                UsichtMover.initControls(this);
            }
        });

        addUniqueEvent(content_usicht_items, 'mouseleave', function() {
            // Hier bewusst KEINE Pruefung auf html.mouse: Aufraeumen muss
            // auch laufen, wenn zwischen Betreten und Verlassen auf Touch
            // umgeschaltet wurde - sonst bliebe isHovering stehen und der
            // Slider liefe endlos weiter.
            UsichtMover.isHovering = null;

            // Es sei denn, das Video gehoert gerade dem Autoplay: das hat
            // seine eigene Ausblende, ein hartes videoAbraeumen risse sie
            // mitten im Bild ab.
            if (!UsichtVideoAuto.aktive.has(this)) UsichtMover.videoAbraeumen(this);
            const ael = this.querySelector("a");
            if (ael?.dataset.originaltitle) ael.title = ael.dataset.originaltitle;
            
            // Batch Updates
            Utils.batchDOMUpdates(() => {
                this.querySelectorAll("a>span:first-child>ul.mover li.select").forEach(el => el.classList.remove("select"));
                this.setAttribute('data-mover_current', 1);
                
                const element = this.querySelector("a>span:first-child>span:first-child");
                if (element) element.style.transform = "translate3D(0, 0, 0)";
            });
        }, { name: 'mouseleave_content_usicht_items' });
    }
};


/**
 * ===================================================================
 * XIX b. Usicht Video ohne Hover
 * ===================================================================
 * Der UsichtMover haengt vollstaendig am Hover - setupEvents bindet nur
 * unter `html.mouse`. Auf Geraeten ohne Hover war das Video damit gar nicht
 * erreichbar.
 *
 * Ausgeloest wird hier nicht durch Tippen, sondern durch Verweilen: bleibt
 * der Nutzer beim Scrollen stehen, laeuft das Video der SICHTBARSTEN Kachel
 * an. Das ist die Entsprechung zum Hover - dort ist das Anhalten der Maus
 * das Signal, hier das Anhalten des Daumens.
 *
 * Drei Riegel halten die Kosten in Grenzen, denn hier fragt niemand aktiv
 * nach dem Video: RUHE_MS verhindert, dass Durchwischen etwas laedt,
 * START_AB laesst angeschnittene Kacheln am Rand aus, und mehr als
 * MAX_GLEICHZEITIG Videos laufen nie.
 *
 * Gespielt wird wie beim Hover: die Boomerang-Fassung in Dauerschleife,
 * solange die Kachel sichtbar bleibt. Die Vorwaerts-Fassung sparte zwar die
 * Haelfte der Uebertragung, lief aber genau einmal und endete auf dem
 * letzten Bild - auf einer Kachel, die der Nutzer noch vor sich hat, sieht
 * das nach Abbruch aus statt nach Schleife.
 *
 * Bewusst kein Slider-Takt: die Bausteine des Movers werden wiederverwendet
 * (videoElement, videoStarten, videoAbraeumen, isVideoUnerwuenscht), aber
 * ohne Fortschrittsbalken, Weiterschalten und Notbremsen.
 */
const UsichtVideoAuto = {
    // Erst wenn so lange nicht gescrollt wurde, laeuft etwas an. Kurz genug,
    // dass es wie eine Reaktion wirkt; lang genug, dass Durchwischen ueber
    // zwanzig Kacheln keinen einzigen Ladevorgang ausloest.
    RUHE_MS: 700,

    // Schmitt-Trigger. Zwei Schwellen, nicht eine: mit nur einer reisst das
    // Video beim normalen Weiterscrollen genau dann ab, wenn der Nutzer
    // ohnehin gleich stehen bleibt.
    START_AB: 0.6,
    STOPP_UNTER: 0.3,

    // Ein laufendes Video weicht erst, wenn der Herausforderer deutlich mehr
    // Flaeche zeigt. Ohne diesen Vorsprung fuehrt jedes Nachscrollen um
    // wenige Pixel zu Abbruch, load() und neuem Ladevorgang - mehrfach
    // hintereinander, waehrend der Nutzer nur die Hand bewegt hat.
    WECHSEL_VORSPRUNG: 1.2,

    // Mobil ist das Raster zweispaltig: zwei Kacheln nebeneinander sind
    // exakt gleich sichtbar, und beide zeigen ein Produkt, das der Nutzer
    // gerade ansieht. Eine davon stumm zu lassen, weil die Leserichtung
    // gegen sie entschieden hat, ist willkuerlich. Zwei ist die Breite der
    // Reihe - nicht mehr, denn jedes weitere Video kostet Leitung und einen
    // Decoder, und iOS deckelt die Zahl gleichzeitiger Video-Elemente.
    MAX_GLEICHZEITIG: 2,

    // Zwischen src-Zuweisung und loadeddata vergeht Zeit. In dieser Spanne
    // wird nicht gewechselt, sonst verwirft eine Entscheidung ein Video,
    // das noch gar nicht zu sehen war.
    //
    // ACHTUNG: Der Verdraengungszweig in pruefen() - also WECHSEL_VORSPRUNG
    // und diese Sperre - ist von usicht-video-mobil-cdp.test.py NICHT
    // gedeckt. Der Test scrollt vor jeder Messung auf 0, damit die Faelle
    // unabhaengig sind, und faehrt pruefen() deshalb nie mit vollen
    // Plaetzen UND einem staerkeren Herausforderer. Eine weitere
    // Scrollposition loest das nicht: im Hysterese-Fall spielt planmaessig
    // etwas anderes als die Rangliste nennt, der Assert dort braucht also
    // ein eigenes Kriterium. Wer hier etwas aendert, hat kein Netz.
    STARTSPERRE_MS: 400,

    // Flaechenunterschiede darunter gelten als Gleichstand.
    GLEICHSTAND: 0.02,

    // Dauer der Ueberblendung. Muss zur transition im cssText von
    // videoElement passen (.35s): kuerzer, und es wird mitten in der
    // Blende abgeraeumt; laenger, und ein unsichtbares Video haelt seinen
    // Decoder unnoetig offen.
    BLENDE_MS: 350,

    // Laufende Videos: Kachel -> Startzeitpunkt. Der Zeitpunkt haengt am
    // einzelnen Eintrag, weil die Startsperre je Video gilt und nicht fuer
    // den Spieler als Ganzes.
    aktive: new Map(),
    ruheTimer: null,
    beobachter: null,
    // Kacheln, die der Observer gerade als "im Bild" fuehrt. Nur Vorfilter -
    // die Rangfolge wird frisch gemessen, nicht aus seinen Werten gelesen.
    imBild: null,
    beobachtet: null,
    // Kacheln, die auch auf der kleinsten Stufe noch gestockt haben. Sie
    // bleiben fuer den Rest der Seite beim Standbild - sonst startete
    // pruefen() sie beim naechsten Scroll-Halt neu, und das Stocken begaenne
    // von vorn.
    aufgegeben: null,

    setupEvents() {
        // (hover: none) statt 'ontouchstart': gefragt ist, ob es ein Hover
        // gibt, ueber das der Mover das Video ohnehin startet. Auf dem
        // Touch-Notebook mit Maus bleibt dieser Pfad deshalb aus.
        //
        // isVideoUnerwuenscht ist dieselbe Pruefung wie auf dem Desktop:
        // saveData, 2G/3G, < 4 Kerne. Hier wiegt sie schwerer als dort, weil
        // niemand um das Video gebeten hat.
        //
        // Genau deshalb bleibt prefers-reduced-motion an DIESER Stelle ein
        // Ausschlussgrund, obwohl es seit 2026-09-21 aus isVideoUnerwuenscht
        // heraus ist: Der Trennstrich verlaeuft nicht zwischen den Seiten,
        // sondern zwischen angefordert und unangefordert. Ein geoeffneter
        // Artikel und ein gehaltener Mauszeiger sind eine Aufforderung — ein
        // Video, das beim Scrollen von selbst neben Preisen und Text
        // anlaeuft, ist keine (WCAG 2.2 SC 2.2.2, Level A).
        const bewegungUnerwuenscht = !!(window.matchMedia
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        const erlaubt = window.matchMedia
            && window.matchMedia('(hover: none)').matches
            && !bewegungUnerwuenscht
            && !UsichtMover.isVideoUnerwuenscht();

        // Aufraeumen, falls init_nocr erneut laeuft (AJAX-Navigation).
        this.allesStoppen();
        if (this.beobachter) {
            this.beobachter.disconnect();
            this.beobachter = null;
        }
        this.imBild = new Set();
        this.beobachtet = new WeakSet();
        this.aufgegeben = new WeakSet();

        if (!erlaubt) return;
        if (!domCache.get('#content_usicht')) return;

        // Die Schwellen decken START_AB und STOPP_UNTER ab, damit der
        // Observer in der Naehe beider Entscheidungen ueberhaupt meldet.
        this.beobachter = new IntersectionObserver(eintraege => {
            for (const eintrag of eintraege) {
                if (eintrag.isIntersecting) {
                    this.imBild.add(eintrag.target);
                } else {
                    this.imBild.delete(eintrag.target);
                    this.stoppen(eintrag.target);
                }
            }
            this.anstossen();
        }, { threshold: [0, 0.3, 0.6, 0.9, 1] });

        this.nachbeobachten();

        addUniqueEvent(window, 'scroll', () => this.anstossen(), { passive: true, name: 'scroll_usicht_video' });
        addUniqueEvent(window, 'resize', () => this.anstossen(), { passive: true, name: 'resize_usicht_video' });
        addUniqueEvent(document, 'visibilitychange', () => {
            if (document.hidden) this.allesStoppen();
            else this.anstossen();
        }, { passive: true, name: 'visibility_usicht_video' });

        // Nicht waehrend des Seitenaufbaus anfangen: das Video konkurriert
        // sonst mit den zwei Dutzend Kachelbildern um dieselbe Leitung.
        if (document.readyState === 'complete') this.anstossen();
        else addUniqueEvent(window, 'load', () => this.anstossen(), { passive: true, once: true, name: 'load_usicht_video' });
    },

    /**
     * Nachgeladene Kacheln mitnehmen - eine zweite Seite
     * (content_usicht_page_show) oder ein Filterwechsel tauscht das <ul>
     * aus, ohne dass setupEvents erneut laeuft.
     */
    nachbeobachten() {
        if (!this.beobachter) return;
        const kacheln = domCache.getAll('#content_usicht>ul>li[data-video]');
        for (let i = 0; i < kacheln.length; i++) {
            const li = kacheln[i];
            if (this.beobachtet.has(li)) continue;
            this.beobachtet.add(li);
            this.beobachter.observe(li);
        }
    },

    /** Setzt die Ruhe-Uhr zurueck. Erst ihr Ablauf entscheidet. */
    anstossen() {
        clearTimeout(this.ruheTimer);
        this.ruheTimer = setTimeout(() => this.pruefen(), this.RUHE_MS);
    },

    /**
     * Der sichtbare Bereich ist der Viewport OHNE die Kopfzeile: mobil ist
     * header>div sticky (style_responsive.css:639), und was dahinter liegt,
     * sieht niemand - IntersectionObserver und innerHeight wissen davon
     * nichts.
     */
    nutzbarerBereich() {
        let oben = 0;
        const kopf = domCache.get('header>div');
        if (kopf) {
            const stil = window.getComputedStyle(kopf);
            if (stil.position === 'sticky' || stil.position === 'fixed') {
                oben = Math.max(0, kopf.getBoundingClientRect().bottom);
            }
        }
        return { oben: oben, unten: window.innerHeight };
    },

    /**
     * Gemessen wird der BILDBEREICH, nicht die Kachel: dort laeuft das
     * Video. Die Kachel ist mit Titel und Preis rund ein Drittel hoeher -
     * stuende nur ihr Textteil im Bild, galte sie sonst als gut sichtbar,
     * obwohl vom Foto nichts zu sehen ist.
     *
     * Und gemessen wird JETZT, nicht aus den Werten des Observers: der
     * meldet nur beim Ueberschreiten seiner Schwellen, dazwischen veraltet
     * sein Anteil.
     */
    sichtbareFlaeche(li, bereich) {
        const bild = li.querySelector('a>span:first-child');
        if (!bild) return { flaeche: 0, anteil: 0, mitte: 0 };

        const k = bild.getBoundingClientRect();
        if (!k.width || !k.height) return { flaeche: 0, anteil: 0, mitte: 0 };

        const hoehe = Math.max(0, Math.min(k.bottom, bereich.unten) - Math.max(k.top, bereich.oben));
        const breite = Math.max(0, Math.min(k.right, window.innerWidth) - Math.max(k.left, 0));
        const flaeche = hoehe * breite;

        return {
            flaeche: flaeche,
            anteil: flaeche / (k.width * k.height),
            mitte: (k.top + k.bottom) / 2
        };
    },

    /**
     * Alle Kacheln, die genug zu sehen sind - absteigend nach Rang. Drei
     * Kriterien, in dieser Reihenfolge:
     *
     *   1. sichtbare Flaeche in px²
     *   2. bei fast gleicher Flaeche: naeher an der Mitte des Bereichs
     *   3. bei weiterhin Gleichstand: Leserichtung, links vor rechts
     *
     * Der dritte Punkt ist kein Sonderfall, sondern der Normalfall: mobil
     * ist das Raster zweispaltig, und zwei Kacheln nebeneinander sind exakt
     * gleich sichtbar UND exakt gleich weit von der Mitte entfernt. Ohne
     * ihn entschiede die Einfuegereihenfolge der Sammlung - also Zufall.
     *
     * Seit beide Spalten laufen duerfen, entscheidet er nur noch die
     * Startreihenfolge innerhalb der Reihe, nicht mehr, wer ueberhaupt
     * drankommt.
     *
     * Die ganze Liste, nicht nur der Sieger: pruefen() besetzt damit
     * MAX_GLEICHZEITIG Plaetze und braucht dafuer auch den Zweiten.
     */
    besteKacheln(bereich) {
        const mitte = (bereich.oben + bereich.unten) / 2;
        const kandidaten = [];

        this.imBild.forEach(li => {
            const mass = this.sichtbareFlaeche(li, bereich);
            if (mass.anteil < this.START_AB) return;
            kandidaten.push({
                li: li,
                flaeche: mass.flaeche,
                abstand: Math.abs(mass.mitte - mitte)
            });
        });

        if (!kandidaten.length) return kandidaten;

        const gleichstand = this.GLEICHSTAND;
        kandidaten.sort((a, b) => {
            const groesser = Math.max(a.flaeche, b.flaeche);
            if (groesser > 0 && Math.abs(a.flaeche - b.flaeche) / groesser > gleichstand) {
                return b.flaeche - a.flaeche;
            }
            if (Math.abs(a.abstand - b.abstand) > 1) return a.abstand - b.abstand;
            return (a.li.compareDocumentPosition(b.li) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
        });

        return kandidaten;
    },

    pruefen() {
        if (document.hidden) return;
        this.nachbeobachten();

        // Steht keine Kachel mit Video im Bild, ist nichts zu entscheiden.
        // Das spart bei jedem Scroll-Halt auf einer video-losen Seite das
        // getComputedStyle und die Messschleifen.
        if (!this.imBild.size) {
            this.allesStoppen();
            return;
        }

        const bereich = this.nutzbarerBereich();

        // Was aus dem Blick geraet, hoert auf. Die Schleife laeuft ueber
        // eine Kopie: stoppen() aendert die Sammlung, ueber die iteriert
        // wird.
        for (const li of [...this.aktive.keys()]) {
            if (this.sichtbareFlaeche(li, bereich).anteil < this.STOPP_UNTER) this.stoppen(li);
        }

        const rang = this.besteKacheln(bereich);
        if (!rang.length) return;

        for (const kandidat of rang.slice(0, this.MAX_GLEICHZEITIG)) {
            if (this.aktive.has(kandidat.li)) continue;

            // Gehoert die Kachel gerade dem Hover-Slider, Finger weg:
            // beide Spieler benutzen dasselbe <video>. Der mouseenter
            // oben beendet das Autoplay, wenn der Mover uebernimmt -
            // das hier ist die Gegenrichtung. Ohne sie setzt starten()
            // loop und eine neue Quelle unter dem laufenden Mover weg,
            // dessen onended dann nie feuert.
            if (UsichtMover.isHovering === kandidat.li) continue;
            if (this.aufgegeben.has(kandidat.li)) continue;

            // Freier Platz: einfach besetzen. Das ist der Normalfall in der
            // zweispaltigen Reihe - die zweite Kachel verdraengt nichts,
            // sie stand nur bisher nie zur Wahl.
            if (this.aktive.size < this.MAX_GLEICHZEITIG) {
                this.starten(kandidat.li);
                continue;
            }

            // Alles besetzt: Der Herausforderer tritt gegen das am
            // wenigsten sichtbare laufende Video an - und muss deutlich
            // mehr zeigen, sonst kostet jedes Nachscrollen um wenige Pixel
            // einen Abbruch und einen neuen Ladevorgang.
            let schwaechstes = null;
            let schwaechsteFlaeche = Infinity;
            for (const li of this.aktive.keys()) {
                const flaeche = this.sichtbareFlaeche(li, bereich).flaeche;
                if (flaeche < schwaechsteFlaeche) {
                    schwaechsteFlaeche = flaeche;
                    schwaechstes = li;
                }
            }
            if (!schwaechstes) break;
            if (performance.now() - this.aktive.get(schwaechstes) < this.STARTSPERRE_MS) continue;
            if (kandidat.flaeche < schwaechsteFlaeche * this.WECHSEL_VORSPRUNG) continue;

            this.stoppen(schwaechstes);
            this.starten(kandidat.li);
        }
    },

    starten(li) {
        if (!li.dataset.video) return;

        // videoElement baut das <video> in den Slider-Streifen; der Mover
        // schiebt es sonst per style.left ueber den richtigen Slide. Hier
        // wird der Streifen nie verschoben - es gehoert ueber den ersten.
        const video = UsichtMover.videoElement(li);

        // Blendet dieses Element gerade aus, gehoert sein Aufraeum-Timer
        // abgebrochen - sonst raeumt er gleich das eben gestartete Video
        // ab. Der Timer haengt am Element, damit er nur DIESE Kachel
        // betrifft und nicht eine andere, die parallel ausblendet.
        clearTimeout(video._blendeTimer);
        video._blendeTimer = null;

        video.style.left = '0';

        // Dauerschleife, solange die Kachel sichtbar bleibt - wie der
        // Hover-Slider auf einer Kachel mit einem einzigen Bild. Das Ende
        // des Videos ist damit keine Entscheidung mehr; es hoert auf, wenn
        // die Kachel aus dem Blick geraet, und das entscheidet pruefen().
        video.loop = true;

        // Dieselbe Wahl wie auf dem Desktop: pickVideoSrc misst die
        // Kachelbreite mal Pixeldichte (bei Faktor 2 gedeckelt) und nimmt
        // die passende der vier Stufen. Das li traegt dafuer data-video und
        // data-video-srcset und ist genau so breit wie sein Bild.
        //
        // Und die Boomerang-Fassung (zweites Argument false): sie laeuft in
        // sich zurueck und schliesst die Schleife nahtlos. Die
        // Vorwaerts-Fassung waere halb so gross (gemessen ueber 155 Videos:
        // 1280 -> 634 KB im Mittel), springt an der Naht aber sichtbar auf
        // Bild 0 zurueck - bei einer Kachel, die der Nutzer minutenlang vor
        // sich hat, faellt genau das auf.
        UsichtMover.videoQuelleSetzen(video, () => UsichtMover.pickVideoSrc(li, false), () => {
            this.aufgegeben.add(li);
            this.stoppen(li);
        });

        // Kein onended: in der Schleife feuert es nie.
        video.onerror = () => this.stoppen(li);

        this.aktive.set(li, performance.now());

        UsichtMover.videoStarten(video, true);
    },

    /** Beendet ALLE laufenden Videos - Seitenwechsel, Tab verlassen, Filter. */
    allesStoppen() {
        for (const li of [...this.aktive.keys()]) this.stoppen(li);
    },

    stoppen(li) {
        if (!li || !this.aktive.has(li)) return;
        this.aktive.delete(li);

        const video = li.querySelector('a>span:first-child>span:first-child>video');
        if (!video) return;

        // Erst ausblenden, dann abraeumen - und nicht umgekehrt.
        // videoAbraeumen ruft load(), und das leert das Bild im selben
        // Augenblick: die Transition kaeme nie zum Zug, das Standbild
        // spraenge hart zurueck. Waehrend der Blende laeuft das Video
        // weiter, damit es nicht auf einem Standbild einfriert.
        video.style.opacity = '0';
        video.onended = null;
        video.onerror = null;

        // Und das Einblenden abbestellen. videoStarten haengt fuer die
        // sanfte Blende ein onloadeddata ein, das die Deckkraft auf 1
        // setzt; videoAbraeumen nullt es zwar, aber erst am ENDE der
        // 350 ms. Wer anlaeuft und sofort weiterscrollt, laedt genau in
        // diesem Fenster fertig - das verworfene Video wuerde sichtbar
        // und danach hart per remove() verschwinden.
        video.onloadeddata = null;

        clearTimeout(video._blendeTimer);
        video._blendeTimer = setTimeout(() => {
            video._blendeTimer = null;

            // Laeuft auf dieser Kachel inzwischen wieder etwas, nicht
            // dazwischenfunken. Das gilt fuer beide Spieler: gestoppt wird
            // schon bei 30 % Sichtbarkeit, die Kachel ist da noch
            // hoverbar, und der Mover benutzt dasselbe <video>-Element.
            // Haette er es in diesen 350 ms uebernommen, risse das
            // Aufraeumen ihm Quelle und Taktgeber weg.
            if (this.aktive.has(li) || UsichtMover.isHovering === li) return;
            UsichtMover.videoAbraeumen(li);

            // Und das Element wieder aus dem DOM nehmen. videoAbraeumen
            // gibt zwar die Quelle frei, das <video> selbst bleibt aber
            // stehen - beim Scrollen ueber eine lange Liste sammelt sich
            // eines pro besuchter Kachel an. iOS deckelt die Zahl
            // gleichzeitiger Video-Elemente, und ab dem Limit startet gar
            // nichts mehr. videoElement() baut es beim naechsten Mal neu.
            video.remove();
        }, this.BLENDE_MS);
    }
};


/**
 * ===================================================================
 * XX. Hauptinitialisierung (Performance-optimiert)
 * OHNE overwrite: true - EventService erkennt neue Elemente automatisch
 * ===================================================================
 */

export async function init_nocr() {
    
    domCache.validate();
    
    const html = domCache.getHtml();
    const isFirstLoad = !html.classList.contains('init2');
    const isMobile = html.classList.contains("mobile_size");
    
    // ===================================================================
    // EINMALIGE INITIALISIERUNG (nur beim ersten Seitenload)
    // ===================================================================
    if (isFirstLoad) {
        html.classList.add('init2');

        // Alle synchronen Event-Initialisierungen
        EventHandlers.initBasicEvents();
        EventHandlers.initFooterObserver();
        EventHandlers.initApplePay();
        EventHandlers.initNavigationEvents();
        EventHandlers.initBannerEvents();
        EventHandlers.initShopSelectEvents();
        EventHandlers.initRatingEvents();
        EventHandlers.initNewsletterEvents();
        EventHandlers.initCaptchaEvents();
        EventHandlers.initBasketRightEvents();
        EventHandlers.initBottomMenuEvents();

        ScrollHandler.init();
        TitleAnimation.start();

        // Fire-and-forget - kein await nötig
        if (!isMobile) {
            loadModule('navHover').then(m => m.kopf_nav_over());
        }

        setTimeout(() => loadModule('newsletter').then(m => m.newsletter_vip()), 5000);

        if (domCache.get(".info_opener")) JobsManager.init();
    }

    // ===================================================================
    // BEI JEDEM AUFRUF (auch nach AJAX-Load)
    // ===================================================================

    // Mobile Menu - einziges echtes await am Anfang (muss vor Click-Events fertig sein)
    //if (isMobile) {
    //    const mobilModule = await loadModule('mobil');
    //    await mobilModule.mobile_menu_init();
    //}
    
    // Mobile-Menu Click-Events
    const basketRightMenu = domCache.get(".basket_right .content_mobil_menu");
    if (basketRightMenu) {
        addUniqueEvent(basketRightMenu, 'click', () => {
            window.location.href = "/basket.html";
        }, { name: 'click_basketRightMenu' });
    }
    
    const sitcontentMenu = domCache.get("#sitecontent .content_mobil_menu");
    if (sitcontentMenu) {
        addUniqueEvent(sitcontentMenu, 'click', async function() {
            const mobilModule = await loadModule('mobil');
            mobilModule.mobil_menu_load(this);
        }, { name: 'click_sitcontentMenu' });
    }

    // Alle synchronen Initialisierungen
    EventHandlers.initSearchEvents();
    FilterManager.initMobileFilter();
    ObserverManager.initContentUsichtObserver();
    BasketManager.initArtikelBasket();
    BreadcrumbManager.check();
    ObserverManager.initPageButtonObservers();
    ObserverManager.initGridObservers();
    UsichtMover.setupEvents();
    UsichtVideoAuto.setupEvents();
    EventHandlers.initMiscEvents();
    PasswordManager.init();
    InputValidation.init();
    ReviewsManager.init();
    ContentManagers.initBannerLoad();
    ContentManagers.initBasketRate();

    // Alle async Operationen parallel sammeln
    const asyncTasks = [
        ContentManagers.initBannerTop(),
        EventHandlers.initBasketEvents(),
        EventHandlers.initCheckoutEvents(),
        EventHandlers.initUsichtEvents(),
        ContentManagers.initArtikelContent(),
        ContentManagers.initUsichtFilter(),
        loadModule('form')
    ];

    // Home Content
    if (domCache.getAllArray("#content_home").length) {
        asyncTasks.push(
            loadModule('home').then(m => {
                m.content_home_marke();
                m.content_home_banner_init();
            }),
            loadModule('usicht').then(m => m.content_usicht_artikel_slider())
        );
    }

    // Autocomplete
    if ((domCache.get('.autocomplete') || domCache.get('#map')) && 
        !html.classList.contains('init_autocomplete')) {
        asyncTasks.push(loadModule('autocomplete').then(() => initAutocomplete()));
    }

    // Alle async Tasks parallel ausführen
    const results = await Promise.all(asyncTasks);
    const formModule = results[6]; // form ist der 7. Task (Index 6)

    // Form Initialization (braucht formModule)
    const formElements = domCache.getAll(
        '.table_formular fieldset:not(.table_formular_init) input, ' +
        '.table_formular:not(.table_formular_init) fieldset textarea, ' +
        '.table_formular:not(.table_formular_init) fieldset select'
    );
    
    if (formElements.length) {
        formModule.table_formular_init(formElements);
    }
    formModule.formular_select_init();

    // Banner Hasena (sync, schnell)
    if (domCache.get("#content_usicht_banner_hasena")) banner_hasena_load();

    // Final Setup
    const hasStars = domCache.get(".content_star1") || 
                     domCache.get(".content_star2") || 
                     domCache.get(".content_star3") || 
                     domCache.get(".content_star4") || 
                     domCache.get(".content_star5");
    
    if (hasStars) {
        const buttonRed = domCache.get(".button_red");
        if (buttonRed) buttonRed.disabled = false;
    }
    
    if (domCache.get("#content_artikel") && 
        !getCookie("banner_header_rabatt_hide") && 
        !html.classList.contains("banner_header_rabatt")) {
        setTimeout(() => UIComponents.toggleBannerHeaderRabatt(), 10000);
    }
    
    const waitingButtons = domCache.getAllArray(".button_waiting");
    if (waitingButtons.length) {
        const waitingHtml = "<span class='waiting-ring'><span></span><span></span><span></span></span>";
        for (let i = 0; i < waitingButtons.length; i++) {
            const button = waitingButtons[i];
            const lsElements = button.querySelectorAll(".ls");
            for (let j = lsElements.length - 1; j >= 0; j--) {
                lsElements[j].remove();
            }
            button.insertAdjacentHTML("beforeend", waitingHtml);
        }
    }

    html.classList.remove("load");
    setTimeout(() => html.classList.add("load"), 1000);
}

// Cleanup beim Page Unload
window.addEventListener('beforeunload', () => {
    rafManager.cancelAll();
    STATE.observers.usichtPage.forEach(observer => observer.disconnect());
    STATE.observers.contentUsicht.forEach(observer => observer.disconnect());
    STATE.observers.bannerBox?.disconnect();
}, { passive: true });



// Datei: src/banner.js




function banner_hasena_load() {
  const contentDiv = document.querySelector("#content_usicht_banner_hasena");
  if (!contentDiv.querySelector(".load")) {
    contentDiv.innerHTML += "<a href='/marken/hasena.html' title='zur Markenseite Hasena'></a>";
    contentDiv.classList.add("load");

    const link = contentDiv.querySelector("a");
    link.addEventListener("click", function(event) {
      event.preventDefault();
      getlink(this.href);
    });
  }
}


// Datei: src/shop.kopf.js
// OPTIMIERT!
// Vollständiges DOM-Caching
const LIVESEARCH_CACHE = {
    searchInput: null,
    searchContainer: null,
    searchForm: null,
    sucheElement: null,
    livesearchBody: null,
    mobileSuggestionsSpan: null,
    desktopSuggestionsSpan: null,
    
    clearCache() {
        this.searchInput = null;
        this.searchContainer = null;
        this.searchForm = null;
        this.sucheElement = null;
        this.livesearchBody = null;
        this.mobileSuggestionsSpan = null;
        this.desktopSuggestionsSpan = null;
    }
};

// Glatte Scroll-Animation zum Seitenanfang
function smoothScrollToTop(duration) {
    const start = window.pageYOffset;
    const startTime = performance.now();

    const scrollAnimation = () => {
        const currentTime = performance.now();
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        window.scrollTo(0, start * (1 - progress));

        if (progress < 1) {
            requestAnimationFrame(scrollAnimation);
        }
    };

    requestAnimationFrame(scrollAnimation);
}

// Event Delegation Handler für Suchvorschläge
const handleSuggestionContainerClick = (event) => {
    const link = event.target.closest('a[data-value]');
    
    if (!link) return;

    event.preventDefault();
    LIVESEARCH_CACHE.searchInput.placeholder = link.dataset.value;
    LIVESEARCH_CACHE.searchInput.value = '';
    getlink(link.href);
    
    if (LIVESEARCH_CACHE.desktopSuggestionsSpan) {
        LIVESEARCH_CACHE.desktopSuggestionsSpan.remove();
        LIVESEARCH_CACHE.desktopSuggestionsSpan = null;
    }
    
    LIVESEARCH_CACHE.searchInput.dispatchEvent(new Event('blur'));
};

// Event Delegation Handler für Remove-Buttons
const handleRemoveContainerClick = async (event) => {
    const removeButton = event.target.closest('.remove[data-value]');
    
    if (!removeButton) return;

    const inputElement = LIVESEARCH_CACHE.searchInput;
    const valueToRemove = removeButton.getAttribute("data-value");
    
    if (!valueToRemove) {
        inputElement?.focus();
        return;
    }

    try {
        const cookieValue = await getCookie("suche");
        let searchArray = [];

        if (cookieValue) {
            try {
                const parsed = JSON.parse(cookieValue);

                if (Array.isArray(parsed)) {
                    searchArray = parsed;
                } else if (parsed && typeof parsed === "object") {
                    const keys = Object.keys(parsed);
                    const isNumericKeys = keys.length && keys.every(k => /^\d+$/.test(k));
                    
                    if (isNumericKeys) {
                        searchArray = keys
                            .sort((a, b) => Number(a) - Number(b))
                            .map(k => parsed[k]);
                    } else {
                        searchArray = Object.values(parsed);
                    }
                }
            } catch {
                searchArray = String(cookieValue).split(",").map(s => s.trim());
            }
        }

        // Wert entfernen
        const updatedArray = searchArray.filter(v => v && v !== valueToRemove);

        // Cookie aktualisieren
        setCookie("suche", JSON.stringify(updatedArray), {
            path: "/",
            domain: ".slewo.com",
            expires: 365
        });

        // UI aktualisieren
        if (!html.classList.contains("mobile_size")) {
            if (LIVESEARCH_CACHE.desktopSuggestionsSpan) {
                LIVESEARCH_CACHE.desktopSuggestionsSpan.remove();
                LIVESEARCH_CACHE.desktopSuggestionsSpan = null;
            }
        }

        livesearch_vorschlag();
    } catch (error) {
        console.error("Fehler beim Verarbeiten der Suche:", error);
    }

    inputElement?.focus();
};

// Hauptinitialisierung der Live-Suche
function livesearch_init() {
    const searchContainer = domCache.get("header .suche>div");
    if (!searchContainer) return false;

    const searchForm = searchContainer.querySelector("form");
    const searchInput = searchForm.querySelector("input");
    
    // Vollständiges DOM-Caching
    LIVESEARCH_CACHE.searchContainer = searchContainer;
    LIVESEARCH_CACHE.searchForm = searchForm;
    LIVESEARCH_CACHE.searchInput = searchInput;
    LIVESEARCH_CACHE.sucheElement = searchContainer.closest(".suche");
    LIVESEARCH_CACHE.headerDiv = domCache.get("header>div");

    // Submit-Handler
    const handleSubmit = (event) => {
        event.preventDefault();
        
        if (searchInput.value === "") {
            searchInput.focus();
            return false;
        }

        // Livesearch-Element direkt aus Cache
        if (LIVESEARCH_CACHE.livesearchBody) {
            LIVESEARCH_CACHE.livesearchBody.classList.remove("init");
        }

        searchInput.dispatchEvent(new Event("focusout"));
        LIVESEARCH_CACHE.sucheElement.classList.add("submit");
        getlink("/search/?q=" + searchInput.value);
        livesearch_vorschlag();
        
        return false;
    };

    // Konsolidierter Focus-Leave Handler
    const handleFocusLeave = function() {
        LIVESEARCH_CACHE.sucheElement.classList.remove("focus");
    };

    // Focus-Handler
    const handleFocus = function() {
        
        if (!html.classList.contains('captcha')) {
            html.classList.add('botcheck');
            init();
        }
        
        LIVESEARCH_CACHE.sucheElement.classList.add("focus");
        LIVESEARCH_CACHE.sucheElement.classList.remove("submit");

        if (html.classList.contains("mobile_size")) {
            // Mobile Livesearch Container erstellen (nur einmal)
            if (!LIVESEARCH_CACHE.livesearchBody) {
                const livesearchDiv = document.createElement("div");
                livesearchDiv.classList.add("livesearch");
                livesearchDiv.innerHTML = "<span></span>";
                body.appendChild(livesearchDiv);
                
                LIVESEARCH_CACHE.livesearchBody = livesearchDiv;
                LIVESEARCH_CACHE.mobileSuggestionsSpan = livesearchDiv.querySelector("span");

                // Passive Event Listener für bessere Scroll-Performance
                livesearchDiv.addEventListener("touchstart", () => {
                    searchInput.blur();
                }, { passive: true });
            }

            // History State Management mit Cache
            if (!zoom_history && !LIVESEARCH_CACHE.livesearchBody?.classList.contains("init")) {
                history.pushState({livesearch: true}, "", window.location.href);
            }
            zoom_history = null;

            livesearch_vorschlag();

            // Batch DOM-Updates mit gecachten Elementen
            const livesearchElement = LIVESEARCH_CACHE.livesearchBody;
            
            livesearchElement.classList.remove("none");
            livesearchElement.dataset.sh = window.innerHeight;
            livesearchElement.style.paddingTop = LIVESEARCH_CACHE.headerDiv.offsetHeight + "px";
            
            html.classList.add("load_suche");
            livesearchElement.classList.add("init");
            
            smoothScrollToTop(300);

            livesearch_init_load();
        } else {
            // Desktop: Vorschläge initialisieren
            if (!LIVESEARCH_CACHE.desktopSuggestionsSpan) {
                livesearch_vorschlag();
            }
        }
    };

    // Event-Listener registrieren
    addUniqueEvent(searchForm, "submit", handleSubmit);
    addUniqueEvent(searchInput, "focusout", handleFocusLeave);
    addUniqueEvent(searchInput, "focus", handleFocus);

    // Falls Input bereits Focus hat, Events neu triggern
    if (searchInput.matches(":focus")) {
        searchInput.dispatchEvent(new Event("blur"));
        searchInput.dispatchEvent(new Event("focus"));
    }

    livesearch_init_load();
}

// Suchvorschläge laden und anzeigen
async function livesearch_vorschlag() {
    const maxSuggestions = html.classList.contains('mobile_size') ? 10 : 100;
    const searchInput = LIVESEARCH_CACHE.searchInput;
    
    if (!searchInput?.dataset.vorschlag) return;

    const loadedValues = [];
    const htmlParts = [];

    // Letzte Suchen aus Cookie laden
    let searchHistory = await getCookie('suche');
    searchHistory = searchHistory ? JSON.parse(searchHistory) : {};

    if (searchHistory && Object.keys(searchHistory).length) {
        htmlParts.push('<fieldset><legend>letzte Suche</legend><ul>');

        for (let index in searchHistory) {
            if (loadedValues.length > 5) break;
            
            const value = searchHistory[index];
            if (!loadedValues.includes(value)) {
                htmlParts.push(`<li><a data-value="${value}" href="/search/?q=${value}">${value}</a><span class="remove" data-value="${value}"></span></li>`);
                loadedValues.push(value);
            }
        }
        htmlParts.push('</ul></fieldset>');
    }

    // Weitere Vorschläge
    htmlParts.push('<fieldset><legend>andere Kunden suchten</legend><ul>');
    const suggestions = JSON.parse(searchInput.dataset.vorschlag);

    for (let index in suggestions) {
        if (loadedValues.length > maxSuggestions) break;
        
        const value = suggestions[index];
        if (!loadedValues.includes(value)) {
            htmlParts.push(`<li><a data-value="${value}" href="/search/?q=${value}">${value}</a></li>`);
            loadedValues.push(value);
        }
    }
    htmlParts.push('</ul></fieldset>');

    // Einmaliger String-Join
    const vorschlagHTML = htmlParts.join('');

    // Desktop-Suggestions-Span cachen
    if (!LIVESEARCH_CACHE.desktopSuggestionsSpan) {
        let spanElement = LIVESEARCH_CACHE.searchContainer.querySelector('span');
        if (!spanElement) {
            spanElement = document.createElement('span');
            LIVESEARCH_CACHE.searchContainer.appendChild(spanElement);
        }
        LIVESEARCH_CACHE.desktopSuggestionsSpan = spanElement;
        
        // Event Delegation für Desktop-Container (nur einmal)
        addUniqueEvent(spanElement, "click", handleSuggestionContainerClick);
        addUniqueEvent(spanElement, "click", handleRemoveContainerClick);
    }

    // Mobile-Suggestions-Span cachen (falls vorhanden)
    if (html.classList.contains("mobile_size") && LIVESEARCH_CACHE.livesearchBody && !LIVESEARCH_CACHE.mobileSuggestionsSpan) {
        LIVESEARCH_CACHE.mobileSuggestionsSpan = LIVESEARCH_CACHE.livesearchBody.querySelector("span");
        
        if (LIVESEARCH_CACHE.mobileSuggestionsSpan) {
            // Event Delegation für Mobile-Container (nur einmal)
            addUniqueEvent(LIVESEARCH_CACHE.mobileSuggestionsSpan, "click", handleSuggestionContainerClick);
            addUniqueEvent(LIVESEARCH_CACHE.mobileSuggestionsSpan, "click", handleRemoveContainerClick);
        }
    }

    // Batch-Update OHNE querySelectorAll
    const targets = [LIVESEARCH_CACHE.desktopSuggestionsSpan, LIVESEARCH_CACHE.mobileSuggestionsSpan];
    targets.forEach(span => {
        if (span) {
            span.innerHTML = vorschlagHTML;
        }
    });
}

// Live-Suche mit Verzögerung
let currentSearchValue = '';
let searchTimeout;

function livesearch_init_load() {
    const inputElement = LIVESEARCH_CACHE.searchInput;
    
    if (!inputElement) return;
    
    const handleKeyup = function() {
        if (currentSearchValue === this.value) return;
        
        currentSearchValue = this.value;
        clearTimeout(searchTimeout);
        
        searchTimeout = setTimeout(() => {
            ajax({
                type: "POST",
                url: "/search.ajax",
                data: `search=${encodeURIComponent(currentSearchValue)}`,
                cache: false
            }).then(response => {
                if (!LIVESEARCH_CACHE.sucheElement?.classList.contains("focus")) return;

                if (response) {
                    // Desktop-Span cachen falls noch nicht vorhanden
                    if (!LIVESEARCH_CACHE.desktopSuggestionsSpan) {
                        let spanElement = LIVESEARCH_CACHE.searchContainer.querySelector("span");
                        if (!spanElement) {
                            spanElement = document.createElement("span");
                            LIVESEARCH_CACHE.searchContainer.appendChild(spanElement);
                        }
                        LIVESEARCH_CACHE.desktopSuggestionsSpan = spanElement;
                        
                        // Event Delegation (nur einmal)
                        addUniqueEvent(spanElement, "click", handleSuggestionContainerClick);
                        addUniqueEvent(spanElement, "click", handleRemoveContainerClick);
                    }
                    
                    // Batch-Update mit gecachten Elementen
                    const targets = [LIVESEARCH_CACHE.desktopSuggestionsSpan, LIVESEARCH_CACHE.mobileSuggestionsSpan];
                    targets.forEach(el => {
                        if (el) {
                            el.innerHTML = response;
                        }
                    });

                    // Batch classList Updates
                    LIVESEARCH_CACHE.sucheElement.classList.add("ls");
                    LIVESEARCH_CACHE.sucheElement.classList.remove("submit");
                } else {
                    if (!html.classList.contains("mobile_size")) {
                        if (LIVESEARCH_CACHE.desktopSuggestionsSpan) {
                            LIVESEARCH_CACHE.desktopSuggestionsSpan.remove();
                            LIVESEARCH_CACHE.desktopSuggestionsSpan = null;
                        }
                    }
                    LIVESEARCH_CACHE.sucheElement.classList.remove("ls");
                }
            });
        }, 500);
    };

    addUniqueEvent(inputElement, "keyup", handleKeyup);
}

// Datei: src/ratgeber.js
/**
 * Ratgeber-Block: Trennlinien am Spaltenende ausblenden.
 *
 * **Warum das nicht in CSS geht.** Der Block laeuft zweispaltig
 * (`columns: 2`, style.css:1130). Die Trennlinie zwischen zwei Abschnitten
 * ist ein `border-bottom` an `.ratgeber__section` — unten statt oben, damit
 * sie im Zweispaltensatz nie am Kopf einer Spalte landet. Was bleibt, ist ihr
 * Gegenstueck: Der Abschnitt, der am FUSS einer Spalte endet, zeichnet seine
 * Linie dort ins Leere. Ueber dem vollbreiten Fragenblock sah das aus wie eine
 * halbe, abgebrochene Linie.
 *
 * CSS kann diesen Abschnitt nicht benennen. Der Spaltenumbruch entsteht beim
 * Layout und ist keine Stelle im DOM: `:last-child` trifft den letzten
 * Abschnitt des Dokuments, nicht den letzten einer Spalte, und einen Selektor
 * fuer „letztes Element einer Spalte" gibt es nicht. Gemessen werden kann es
 * aber — genau das tut diese Datei.
 *
 * **Sie faellt sauber aus.** Ohne JavaScript bleibt der Zustand von vorher:
 * alle Linien sichtbar, nichts kaputt. Sie greift nur auf Seiten mit
 * `.ratgeber`-Block und bricht sonst sofort ab.
 *
 * Warum hier und nicht im Textblock selbst: Die Kategorietexte tragen ihr HTML
 * fertig in `shop_meta_info`. Ein Skript, das dort eingebettet waere, erreichte
 * die bereits gespeicherten Texte erst beim naechsten Schreiben — eine Datei im
 * Bundle wirkt sofort auf alle. Dieselbe Entscheidung wie beim Stylesheet am
 * 2026-09-08.
 */
(function () {
  'use strict';

  var KLASSE = 'ratgeber__section--spaltenende';

  /**
   * Welche Abschnitte enden am Fuss einer Spalte?
   *
   * **Gemessen wird an Fragmenten, nicht an Umrissen.** Im Mehrspaltensatz
   * zerlegt der Browser einen Abschnitt, der nicht mehr in die Spalte passt:
   * ein Stueck unten in der einen Spalte, der Rest oben in der naechsten.
   * `getBoundingClientRect()` liefert dafuer die Vereinigung beider Stuecke —
   * ein Kasten ueber die volle Breite, der weder einer Spalte zuzuordnen ist
   * noch irgendwo real steht. `getClientRects()` liefert stattdessen jeden
   * Teil einzeln.
   *
   * Das ist keine Feinheit, sondern der Fall selbst: Bei 900 px lief am
   * 2026-09-09 „Essen und Wohnen" ueber den Umbruch. Sein Umriss deckte
   * dadurch beide Spalten, die damalige Breitenregel hielt ihn fuer einen
   * vollbreiten Block und sortierte ihn aus — markiert wurde der Abschnitt
   * darueber, dessen Linie mitten in der Spalte steht.
   *
   * Der Rest folgt aus `box-decoration-break: slice` (dem Standard): Die
   * untere Kante wird nur am **letzten** Fragment gezeichnet. Also zaehlt je
   * Abschnitt genau dieses eine, und die Frage lautet, ob es am tiefsten
   * Punkt seiner Spalte sitzt.
   */
  function spaltenenden(abschnitte) {
    var boeden = {};
    var schlussteile = [];
    var i;
    var r;
    for (i = 0; i < abschnitte.length; i++) {
      var teile = [];
      var alle = abschnitte[i].getClientRects();
      for (r = 0; r < alle.length; r++) {
        if (alle[r].width > 0 && alle[r].height > 0) { teile.push(alle[r]); }
      }
      if (!teile.length) { continue; }
      // **Vollbreite Bloecke gehoeren nicht in die Spaltenrechnung.** Der
      // Fragenblock laeuft ueber beide Spalten und steht ganz unten; ohne
      // diese Zeile waere er der unterste Teil der linken Spur.
      //
      // Gefragt wird die Eigenschaft selbst, nicht die Breite. Ueber die
      // Breite ging es schief: Einspaltig ist JEDER Abschnitt so breit wie der
      // Wickel — dann faellt der ganze Block aus der Rechnung, und die Regel
      // fuer den letzten Abschnitt kam bei 700 und 560 px nie zum Zug.
      var spanne = getComputedStyle(abschnitte[i]).columnSpan;
      // **Kennt der Browser die Eigenschaft nicht, wird gar nicht markiert.**
      // Ohne sie ist der vollbreite Block von einem einspaltigen Abschnitt
      // nicht zu unterscheiden; er landete in der Spaltenrechnung und stuende
      // als letzter da — die Regel weiter unten schuetzte dann den Abschnitt
      // darueber nicht mehr, und ueber `Haeufige Fragen` staenden zwei Linien.
      // Nichts zu tun heisst hier: der Stand von vorher, alle Linien sichtbar.
      // Geprueft wird gegen die beiden gueltigen Werte, nicht gegen
      // `undefined`: Aeltere CSSOM-Fassungen geben fuer eine unbekannte
      // Eigenschaft den Leerstring zurueck, und der waere durchgerutscht.
      if (spanne !== 'all' && spanne !== 'none') { return []; }
      if (spanne === 'all') { continue; }
      for (r = 0; r < teile.length; r++) {
        // Auf ganze Pixel runden: Subpixel-Layout liefert sonst je Stueck
        // eine eigene „Spalte", und dann waere jedes sein eigenes Ende.
        var spur = Math.round(teile[r].left);
        if (!(spur in boeden) || teile[r].bottom > boeden[spur]) {
          boeden[spur] = teile[r].bottom;
        }
      }
      var schluss = teile[teile.length - 1];
      schlussteile.push({
        el: abschnitte[i],
        spur: Math.round(schluss.left),
        unten: schluss.bottom,
      });
    }
    var enden = [];
    for (i = 0; i < schlussteile.length; i++) {
      var boden = boeden[schlussteile[i].spur];
      // Eine Pixel Spielraum: die Kanten sind Fliesskommawerte.
      var am_fuss = boden !== undefined && schlussteile[i].unten >= boden - 1;
      // **Der letzte Abschnitt zaehlt immer dazu.** Unter ihm steht der
      // vollbreite Fragenblock, und der zeichnet seine eigene Oberlinie —
      // beides zusammen ergibt zwei Striche im Abstand von 42 px. In zwei
      // Spalten faellt das nicht auf, weil derselbe Abschnitt dort ohnehin am
      // Spaltenfuss steht; einspaltig (gemessen bei 700 und 560 px) schon.
      if (am_fuss || i === schlussteile.length - 1) {
        enden.push(schlussteile[i].el);
      }
    }
    return enden;
  }

  function anwenden() {
    var wickel = document.querySelectorAll('.ratgeber');
    if (!wickel.length) { return; }
    for (var w = 0; w < wickel.length; w++) {
      var abschnitte = wickel[w].querySelectorAll('.ratgeber__section');
      if (abschnitte.length < 2) { continue; }
      var liste = Array.prototype.slice.call(abschnitte);
      var i;
      // Erst zuruecksetzen — sonst waechst die Markierung bei jedem Lauf, und
      // nach einer Verbreiterung des Fensters fehlten Linien, die wieder
      // mitten in einer Spalte stehen.
      for (i = 0; i < liste.length; i++) {
        liste[i].classList.remove(KLASSE);
      }
      var enden = spaltenenden(liste);
      for (i = 0; i < enden.length; i++) {
        enden[i].classList.add(KLASSE);
      }
    }
  }

  function starten() {
    try {
      anwenden();
    } catch (e) {
      // Eine Trennlinie ist kein Grund, eine Seite zu stoeren.
    }
  }

  var warten = null;
  function spaeter() {
    if (warten) { clearTimeout(warten); }
    warten = setTimeout(starten, 120);
  }

  /**
   * **Feste Zeitpunkte reichen nicht.** Die Bilder des Blocks laden verzoegert
   * (`loading="lazy"`); sie verschieben den Spaltenumbruch also noch nach
   * `load`. Ein `ResizeObserver` auf den Wickel deckt alles ab, was die Hoehe
   * veraendert — Bilder, Schriften, Fenstergroesse.
   *
   * Eine Endlosschleife kann daraus nicht entstehen: `anwenden()` aendert nur
   * eine Rahmenfarbe, und die hat keine Auswirkung auf das Layout.
   */
  function beobachten() {
    if (typeof ResizeObserver !== 'function') { return; }
    var wickel = document.querySelectorAll('.ratgeber');
    if (!wickel.length) { return; }
    var beobachter = new ResizeObserver(spaeter);
    for (var b = 0; b < wickel.length; b++) {
      beobachter.observe(wickel[b]);
    }
  }

  function anlaufen() {
    beobachten();
    starten();
  }

  // **Die Anmeldung des Beobachters gehoert in denselben Zweig wie die erste
  // Rechnung.** Das Bundle kommt per `script async` in den Kopf
  // (`content_kopf.php`, `SLEWO_MODULE_MAP['init']`) und kann vor dem Parsen
  // des Koerpers laufen. Zur Auswertungszeit angemeldet, faende der Beobachter
  // dann keinen `.ratgeber`-Wickel und bliebe fuer die ganze Seite untaetig —
  // genau in dem Fall, fuer den er da ist, denn `loading="lazy"`-Bilder unter
  // dem Falz laden noch nach `load`.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anlaufen);
  } else {
    anlaufen();
  }
  // Fonts und Bilder verschieben den Umbruch nach dem ersten Layout.
  window.addEventListener('load', starten);
  window.addEventListener('resize', spaeter);

})();
